import { formatDate } from "@angular/common";
import { Component, ElementRef, Input, OnInit, ViewChild } from "@angular/core";
import { Form, FormBuilder, FormControl, FormGroup } from "@angular/forms";
import { MatSnackBar } from "@angular/material/snack-bar";
import { Router } from "@angular/router";
import { AdminService } from "../admin.service";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { environment } from "src/environments/environment.prod";

@Component({
  selector: "app-reports",
  templateUrl: "./reports.component.html",
  styleUrls: ["./reports.component.css"],
})
export class ReportsComponent implements OnInit {
  // -------------- Form Group Names --------------

  todoForm: FormGroup;
  quotesForm: FormGroup;
  tripsForm: FormGroup;
  trucksForm: FormGroup;
  ordersForm: FormGroup;
  transportForm: FormGroup;
  driversForm: FormGroup;
  workOrderForm: FormGroup;
  customerForm: FormGroup;
  paymentsForm: FormGroup;
  pre_orderForm: FormGroup;
  pre_orderForm1: FormGroup;
  driForm: FormGroup;
  report_type: any = "quote";
  SearchEnabled: boolean = false;

  advancedTodo: boolean = true;
  advancedQuotes: boolean = true;
  advancedTrips: boolean = true;
  advancedPayments: boolean = true;
  advancedTrucks: boolean = true;
  advancedDrivers: boolean = true;
  advancedOrders: boolean = true;
  advancedCustomers: boolean = true;
  advancedTransporter: boolean = true;
  advancedWorkOrders: boolean = true;
  advancedDRI: boolean = true;

  reportCloseTodo: boolean = false;
  reportCloseQuote: boolean = false;
  reportCloseTrips: boolean = false;
  reportClosePayments: boolean = false;
  reportCloseTrucks: boolean = false;
  reportCloseDrivers: boolean = false;
  reportCloseOrders: boolean = false;
  reportCloseCustomers: boolean = false;
  reportCloseTransporters: boolean = false;
  reportCloseWorkOrders: boolean = false;
  reportCloseDRI: boolean = false;

  todoReport: boolean = false;
  quotesReport: boolean = false;
  tripsReport: boolean = false;
  paymentsReport: boolean = false;
  TrucksReports: boolean = false;
  DriversReports: boolean = false;
  OrdersReports: boolean = false;
  customerReport: boolean = true;
  transporterReport: boolean = true;
  workOrdersReports: boolean = false;
  driReport: boolean = false;
  corporateCustomeReport: boolean = false;
  preOrderReports: boolean = false;
  preOrderReports1: boolean = false;

  // -------------- Tabs --------------

  todo: boolean = false;
  quotes: boolean = true;
  trips: boolean = false;
  payments: boolean = false;
  trucks: boolean = false;
  drivers: boolean = false;
  orders: boolean = false;
  corporatecustomers: boolean = false;
  transporter: boolean = false;
  dri: boolean = false;
  searchData: boolean = false;

  CID: boolean = true;
  Trip_Id: boolean = false;
  corporateCustomer: boolean = true;
  customerDetailsEnable: boolean = false;

  // -------------- Declared Arrays --------------

  downloadArray: any;
  tododownloadArray: any;
  tripsdownloadArray: any;
  trucksdownloadArray: any;
  driversdownloadArray: any;
  ordersdownloadArray: any;
  corporatedownloadArray: any;
  paymentdownloadArray: any;
  WodownloadArray: any;
  transporterdownloadArray: any;
  preOrderDownloadArray: any;
  preOrderDownloadArray1: any;
  dridownloadArray: any;

  // -------------- Arrays --------------

  todoArray: any = [];
  quotesArray: any = [];
  tripsArray: any = [];
  driversArray: any = [];
  ordersArray: any = [];
  transporterArray: any[];
  tax_details: any = [];
  paymentGst: any[];
  paymnetTransGST: any[];
  workOrderssArray: any = [];
  customersArray: any = [];
  paymentsArray: any = [];
  corporatecustomersArray: any = [];
  truckArray: any = [];
  corporateCustomer_page: any = [];
  masterList: any = [];
  filteredTripStatus: string[] = [];
  document_array: any = [];
  preorderArray: any = [];
  preorderArray1: any = [];
  driArray: any = [];

  // -------------- Loadings --------------

  todoloading: boolean = false;
  quotesloading: boolean = false;
  tripsloading: boolean = false;
  paymentsloading: boolean = false;
  trucksloading: boolean = false;
  driversloading: boolean = false;
  ordersloading: boolean = false;
  corporateloading: boolean = false;
  transporterloading: boolean = false;
  workorderloading: boolean = false;
  preorderLoading: boolean = false;
  preorderLoading1: boolean = false;
  driloading: boolean = false;
  driExportLoading: boolean = false;

  pre_orders: boolean = false;
  pre_orders_2: boolean = false;

  date = new FormControl(new Date());
  serializedDate = new FormControl(new Date().toISOString());
  today: any;
  minDate = new Date();
  @Input() max: any;
  maxDate = new Date();
  workorders: boolean;
  token: any;
  pageCount: 1;
  paginationNumber: number = 1;
  fromCityDetails: any;
  totalAmount: any;
  round_amount: any;
  trans_round_amount: any;
  toCityDetails: any;
  truck_weight: any;
  truck_category: any;
  customer_total_receivable: any;
  trans_total_receivable: any;
  driver_id: any;
  fromLocation: any = -1;
  toLocation: any = -1;
  fromDate: any = -1;
  toDate: any = -1;
  lrNo: any = -1;
  vchlNo: any = -1;
  truckCategory: any = -1;
  userType: any = -1;
  tripId: any = -1;
  download: any = 1;
  truckWeight: any = -1;
  vehicleNumber: any = -1;
  bankName: any = -1;
  tripStatus: any = -1;
  truckNo: any = -1;
  workOrderNo: any = -1;
  truckOwnerName: any = -1;
  driverStatus: any = -1;
  orderStatus: any = -1;
  truckFeet: any = -1;
  vehicleStatus: any = -1;
  salesOrderNo: any = -1;
  workorder_no: any = -1;
  truckOwner: any = -1;
  perPage: any = 10;
  page: any = 1;
  paymentPage: any = 1;
  truckpage: any = 1;
  report_status: any = "quote";
  driver_status: any = -1;
  fetch_page: any = 1;
  todo_fetch_page: any = 1;
  quotes_fetch_page: any = 1;
  truck_fetch_page: any = 1;
  trips_fetch_page: any = 1;
  payment_fetch_page: any = 1;
  drivers_fetch_page: any = 1;
  orders_fetch_page: any = 1;
  corporate_customer: any = 1;
  corporate_fetch_page: any = 1;
  transport_fetch_page: any = 1;
  workorder_fetch_page: any = 1;
  pre_order_fetch_page: any = -1;
  pre_order_fetch_page_1: any = -1;
  dri_fetch_page: any = 1;

  currentPage: any = 0;
  startPage: any = 1;
  todoStartPage: number = 1;
  quoteStartPage: any = 1;
  tripsStartPage: any = 1;
  paymentStartPage: any = 1;
  truckStartPage: any = 1;
  driverStartPage: any = 1;
  ordersStartPage: any = 1;
  corporateStartPage: any = 1;
  customerStartPage: any = 1;
  transportStartPage: any = 1;
  workStartPage: any = 1;
  preOrderStartPage: any = 1;
  preOrderStartPage1: any = 1;
  driStartPage: any = 1;

  last_page: any;
  paynowAmt: any;
  round_payamount: any;
  mappingList: any;
  customerDetails_id: any;

  downloadReports: any = 1;
  weight: any = -1;
  todoId: any = -1;
  quotesId: any = -1;
  downloadQuotes: any = 1;
  downloadPreOrder: any = 1;
  searchTruckNumber: any = -1;
  truckNumber: any = -1;

  customerName: any = -1;
  searchQuery: any = -1;
  driverName: any = -1;
  paymentStatus: any = -1;
  totalTax: any = 0;
  totalReceivable: any = 0;
  paymentData: any;
  woid: any = -1;
  @ViewChild("newItem") newItem: ElementRef;
  @ViewChild("trucksTab") trucksTab: ElementRef;
  @ViewChild("driverTab") driverTab: ElementRef;
  @ViewChild("newid") newid: ElementRef;
  @ViewChild("tripsTab") tripsTab: ElementRef;
  @ViewChild("paymentTab") paymentTab: ElementRef;
  @ViewChild("newItemWO") newItemWO: ElementRef;
  @ViewChild("newItemPreorder") newItemPreorder: ElementRef;
  @ViewChild("newItemPreorder1") newItemPreorder1: ElementRef;
  @ViewChild("driTab") driTab: ElementRef;

  @ViewChild("orderTab") orderTab: ElementRef;
  @ViewChild("corporateTab") corporateTab: ElementRef;
  @ViewChild("transporterTab") transporterTab: ElementRef;
  isSearchDisabled: boolean = false;
  isNoDataFound: boolean = false;
  sortColumn: string = "";
  sortDirection: string = "asc";
  isNoRecordsFound: boolean = false;
  isApplyButtonDisabled: boolean = false;
  isSearching: boolean = true;
  transporterIdKeyword: any = "";
  driverIdKeyword: any;
  acc: any = 0;
  selectedPreOrderId: any;
  private isApiCallInProgress = false;

  constructor(
    private services: AdminService,
    private router: Router,
    private snackBar: MatSnackBar,
    private formBuilder: FormBuilder,
    private http: HttpClient
  ) { }

  getSumOfLastTwoPayments(paymentHistory: any[]): number {
    if (!paymentHistory || paymentHistory.length === 0) {
      return 0;
    }
    const lastIndex = paymentHistory.length - 1;
    const lastPayment = paymentHistory[lastIndex]?.amount_paid || 0;
    const secondLastPayment = paymentHistory[lastIndex - 1]?.amount_paid || 0;

    return lastPayment + secondLastPayment;
  }

  ngOnInit(): void {
    this.token = localStorage.getItem("adminToken");
    this.getMappingList();
    this.getAllList();
    this.todoForm = this.formBuilder.group({
      from_date: [""],
      to_date: [""],
      trip_status: [""],
      trip_id: [""],
      acc_name: [""],
      bank_name: [""],
      truck_no: [""],
    });
    this.quotesForm = this.formBuilder.group({
      from_date: [""],
      to_date: [""],
      from_loc: [""],
      to_loc: [""],
      quote_id: [""],
      truck_categ: [""],
      weight: [""],
      load_details: [""],
    });
    this.paymentsForm = this.formBuilder.group({
      from_date: [""],
      to_date: [""],
      from_loc: [""],
      to_loc: [""],
      trip_id: [""],
      payment_status: [""],
    });
    this.tripsForm = this.formBuilder.group({
      from_date: [""],
      to_date: ["", { value: null, disabled: true }],
      from_loc: [""],
      to_loc: [""],
      trip_id: [""],
      vehcl_no: [""],
      veh_cat: [""],
      weight: [""],
      pay_status: [""],
      trip_status: [""],
    });
    this.trucksForm = this.formBuilder.group({
      from_date: [""],
      to_date: [""],
      from_loc: [""],
      to_loc: [""],
      truckowner_name: [""],
      veh_cat: [""],
      weight: [""],
      feet: [""],
      veh_status: [""],
    });
    this.driversForm = this.formBuilder.group({
      truckNumber: [""],
      driverStatus: [""],
    });
    this.ordersForm = this.formBuilder.group({
      from_date: [""],
      to_date: [""],
      from_loc: [""],
      to_loc: [""],
      trip_id: [""],
      veh_cat: [""],
      weight: [""],
      pay_status: [""],
      truckowner_name: [""],
    });
    this.customerForm = this.formBuilder.group({
      from_date: [""],
      to_date: [""],
      from_loc: [""],
      to_loc: [""],
      trip_id: [""],
      vehicle_no: [""],
      lr_no: [""],
      wo_no: [""],
      sales_order: [""],
    });
    this.transportForm = this.formBuilder.group({
      from_date: [""],
      to_date: [""],
      trip_id: [""],
      sales_order: [""],
      truckowner_name: [""],
    });

    this.workOrderForm = this.formBuilder.group({
      from_date: [""],
      to_date: [""],
      salese_Order_Number: [""],
      work_Order_Number: [""],
    });

    this.pre_orderForm = this.formBuilder.group({
      fromDate: [""],
      toDate: [""],
      fromLocation: [""],
      toLocation: [""],
      userType: [""],
      truckCategory: [""],
      woId: [""],
    });
    this.pre_orderForm1 = this.formBuilder.group({
      fromLocation: [""],
      toLocation: [""],
      userType: [""],
      woId: [""],
    });

    this.driForm = this.formBuilder.group({
      route_type: [""],
      truck_type: [""],
      from_city: [""],
      to_city: [""],
      from_date: [""],
      to_date: [""],
      min_fare: [""],
      max_fare: [""],
    });

    this.todoForm.get("from_date")?.valueChanges.subscribe((fromDateValue) => {
      if (fromDateValue) {
        this.todoForm.get("to_date")?.enable();
      } else {
        this.todoForm.get("to_date")?.disable();
      }
    });

    let triptype = "reports";

    localStorage.setItem("tripType", triptype);
    this.todoReport = true;
    this.quotesReport = true;
    this.tripsReport = true;
    this.paymentsReport = true;
    this.TrucksReports = true;
    this.DriversReports = true;
    this.OrdersReports = true;
    this.customerReport = true;
    this.transporterReport = true;
    this.workOrdersReports = true;
    this.driReport = true;
    this.getActiveTab("todo");
  }

  getActiveTab(reportType: any) {
    this.report_type = reportType;
    if (this.report_type == "todo") {
      this.document_array = [];
      this.reportClose("todo");
      this.download = -1;
      this.todo = true;
      this.advancedTodo = true;
      this.quotes = false;
      this.trips = false;
      this.payments = false;
      this.trucks = false;
      this.drivers = false;
      this.orders = false;
      this.corporatecustomers = false;
      this.transporter = false;
      this.workorders = false;
      this.searchData = false;
      this.reportCloseTodo = false;
      this.todoloading = true;
      this.todoStartPage = 1;
      this.todo_fetch_page = 1;
      this.todoReport = true;
      this.dri = false;
      this.driReport = false;
      this.preOrderReports = false;
      this.preOrderReports1 = false;
      this.pre_orders = false;

      this.todoReports(
        this.fromDate,
        this.toDate,
        this.tripStatus,
        this.tripId,
        this.bankName,
        this.truckNo,
        this.download,
        this.perPage,
        this.page
      );
    }
    if (this.report_type == "quote") {
      this.download = -1;
      this.document_array = [];
      this.reportClose("quote");
      this.todo = false;
      this.quotes = true;
      this.advancedQuotes = true;
      this.trips = false;
      this.payments = false;
      this.trucks = false;
      this.drivers = false;
      this.orders = false;
      this.corporatecustomers = false;
      this.transporter = false;
      this.workorders = false;
      this.searchData = false;
      this.reportCloseQuote = false;
      this.quotesloading = true;
      this.fetch_page = 1;
      this.quoteStartPage = 1;
      this.quotesReport = true;
      this.dri = false;
      this.driReport = false;
      this.preOrderReports = false;
      this.preOrderReports1 = false;
      this.pre_orders = false;

      this.quotesForm
        .get("from_date")
        ?.valueChanges.subscribe((fromDateValue) => {
          if (fromDateValue) {
            this.quotesForm.get("to_date")?.enable();
          } else {
            this.quotesForm.get("to_date")?.disable();
          }
        });

      this.quotesReports(
        this.fromLocation,
        this.toLocation,
        this.fromDate,
        this.toDate,
        this.truckCategory,
        this.tripId,
        this.download,
        this.perPage,
        this.quoteStartPage,
        this.report_status
      );
    }
    if (this.report_type == "trips") {
      this.download = -1;
      this.document_array = [];
      this.reportClose("trips");
      this.todo = false;
      this.quotes = false;
      this.trips = true;
      this.advancedTrips = true;
      this.advancedQuotes = false;
      this.payments = false;
      this.trucks = false;
      this.drivers = false;
      this.orders = false;
      this.corporatecustomers = false;
      this.transporter = false;
      this.workorders = false;
      this.searchData = false;
      this.reportCloseTrips = false;
      this.tripsloading = true;
      this.dri = false;
      this.driReport = false;
      this.preOrderReports = false;
      this.preOrderReports1 = false;
      this.pre_orders = false;
      this.trips_fetch_page = 1;
      this.tripsStartPage = 1;

      this.tripsForm
        .get("from_date")
        ?.valueChanges.subscribe((fromDateValue) => {
          if (fromDateValue) {
            this.tripsForm.get("to_date")?.enable();
          } else {
            this.tripsForm.get("to_date")?.disable();
          }
        });
      this.tripsReports(
        this.fromLocation,
        this.toLocation,
        this.fromDate,
        this.toDate,
        this.truckCategory,
        this.truckWeight,
        this.vehicleNumber,
        this.tripId,
        this.tripStatus,
        this.download,
        this.perPage,
        this.page
      );
    }
    if (this.report_type == "payments") {
      this.download = -1;
      this.document_array = [];
      this.reportClose("payments");
      this.todo = false;
      this.payments = true;
      this.advancedPayments = true;
      this.trips = false;
      this.quotes = false;
      this.trucks = false;
      this.drivers = false;
      this.orders = false;
      this.corporatecustomers = false;
      this.transporter = false;
      this.workorders = false;
      this.searchData = false;
      this.reportClosePayments = false;
      this.paymentsloading = true;
      this.dri = false;
      this.driReport = false;
      this.preOrderReports = false;
      this.preOrderReports1 = false;
      this.pre_orders = false;
      this.payment_fetch_page = 1;
      this.quoteStartPage = 1;

      this.paymentsForm
        .get("from_date")
        ?.valueChanges.subscribe((fromDateValue) => {
          if (fromDateValue) {
            this.paymentsForm.get("to_date")?.enable();
          } else {
            this.paymentsForm.get("to_date")?.disable();
          }
        });
      this.paymentsReports(
        this.fromLocation,
        this.toLocation,
        this.fromDate,
        this.toDate,
        this.paymentStatus,
        this.tripId,
        this.download,
        this.perPage,
        this.paymentPage
      );
      this.paymentsHeader();
    }
    if (this.report_type == "trucks") {
      this.download = -1;
      this.document_array = [];
      this.reportClose("trucks");
      this.todo = false;
      this.quotes = false;
      this.trips = false;
      this.payments = false;
      this.trucks = true;
      this.advancedTrucks = true;
      this.drivers = false;
      this.orders = false;
      this.corporatecustomers = false;
      this.transporter = false;
      this.workorders = false;
      this.searchData = false;
      this.reportCloseTrucks = false;
      this.trucksloading = true;
      this.dri = false;
      this.driReport = false;
      this.preOrderReports = false;
      this.preOrderReports1 = false;
      this.pre_orders = false;
      this.truck_fetch_page = 1;
      this.truckStartPage = 1;

      this.trucksReports(
        this.fromLocation,
        this.toLocation,
        this.fromDate,
        this.toDate,
        this.truckCategory,
        this.truckFeet,
        this.truckWeight,
        this.vehicleStatus,
        this.truckOwner,
        this.download,
        this.truckNumber,
        this.perPage,
        this.page
      );
    }
    if (this.report_type == "drivers") {
      this.download = -1;
      this.document_array = [];
      this.reportClose("drivers");
      this.todo = false;
      this.quotes = false;
      this.trips = false;
      this.payments = false;
      this.trucks = false;
      this.drivers = true;
      this.advancedDrivers = true;
      this.orders = false;
      this.corporatecustomers = false;
      this.transporter = false;
      this.workorders = false;
      this.searchData = false;
      this.reportCloseDrivers = false;
      this.driversloading = true;
      this.dri = false;
      this.driReport = false;
      this.preOrderReports = false;
      this.preOrderReports1 = false;
      this.pre_orders = false;
      this.drivers_fetch_page = 1;
      this.driverStartPage = 1;

      this.driversReports(
        this.truckNo,
        this.truckOwnerName,
        this.driverStatus,
        this.download,
        this.driverName,
        this.driver_status,
        this.perPage,
        this.page
      );
    }
    if (this.report_type == "orders") {
      this.download = -1;
      this.document_array = [];
      this.reportClose("orders");
      this.todo = false;
      this.quotes = false;
      this.trips = false;
      this.payments = false;
      this.trucks = false;
      this.drivers = false;
      this.orders = true;
      this.advancedOrders = true;
      this.corporatecustomers = false;
      this.transporter = false;
      this.workorders = false;
      this.searchData = false;
      this.reportCloseOrders = false;
      this.ordersloading = true;
      this.dri = false;
      this.driReport = false;
      this.preOrderReports = false;
      this.preOrderReports1 = false;
      this.pre_orders = false;
      this.orders_fetch_page = 1;
      this.ordersStartPage = 1;

      this.ordersForm
        .get("from_date")
        ?.valueChanges.subscribe((fromDateValue) => {
          if (fromDateValue) {
            this.ordersForm.get("to_date")?.enable();
          } else {
            this.ordersForm.get("to_date")?.disable();
          }
        });

      this.ordersReports(
        this.fromLocation,
        this.toLocation,
        this.fromDate,
        this.toDate,
        this.truckCategory,
        this.tripId,
        this.truckWeight,
        this.orderStatus,
        this.truckOwner,
        this.download,
        this.perPage,
        this.page
      );
    }
    if (this.report_type == "corporatecustomers") {
      this.document_array = [];
      this.reportClose("corporatecustomers");
      this.Trip_Id = false;
      this.CID = true;
      this.todo = false;
      this.quotes = false;
      this.trips = false;
      this.payments = false;
      this.trucks = false;
      this.drivers = false;
      this.orders = false;
      this.corporatecustomers = true;
      this.advancedCustomers = true;
      this.transporter = false;
      this.workorders = false;
      this.searchData = false;
      this.reportCloseCustomers = false;
      this.customerReport = true;
      this.customerDetailsEnable = false;
      this.corporateloading = true;
      this.corporate_customer = 1;
      this.isNoRecordsFound = false;
      this.page = 1;
      this.searchQuery = -1;
      this.document_array = [];
      this.corporateCustomeReport = false;
      this.preOrderReports = false;
      this.preOrderReports1 = false;
      this.pre_orders = false;
      this.corporateCustomer = true;
      this.dri = false;
      this.driReport = false;
      this.getReportsCustomer(this.searchQuery, this.perPage, this.page);
      this.customerForm
        .get("from_date")
        ?.valueChanges.subscribe((fromDateValue) => {
          if (fromDateValue) {
            this.customerForm.get("to_date")?.enable();
          } else {
            this.customerForm.get("to_date")?.disable();
          }
        });
    }
    if (this.report_type == "transporter") {
      this.document_array = [];
      this.last_page = 1;
      this.reportClose("transporter");
      this.todo = false;
      this.quotes = false;
      this.trips = false;
      this.payments = false;
      this.trucks = false;
      this.drivers = false;
      this.orders = false;
      this.corporatecustomers = false;
      this.transporter = true;
      this.advancedTransporter = true;
      this.workorders = false;
      this.searchData = false;
      this.preOrderReports = false;
      this.preOrderReports1 = false;
      this.pre_orders = false;
      this.reportCloseTransporters = false;
      this.transporterloading = true;
      this.dri = false;
      this.driReport = false;
      this.transport_fetch_page = 1;
      this.transportStartPage = 1;
      this.download = -1;
      this.transportForm
        .get("from_date")
        ?.valueChanges.subscribe((fromDateValue) => {
          if (fromDateValue) {
            this.transportForm.get("to_date")?.enable();
          } else {
            this.transportForm.get("to_date")?.disable();
          }
        });
      this.transporterReports(
        this.salesOrderNo,
        this.workOrderNo,
        this.truckOwnerName,
        this.truckNo,
        this.fromDate,
        this.toDate,
        this.tripId,
        this.download,
        this.perPage,
        this.transportStartPage
      );
    }

    if (this.report_type == "workorders") {
      this.document_array = [];
      this.download = -1;
      this.resetWorkOrder();
      this.todo = false;
      this.quotes = false;
      this.trips = false;
      this.payments = false;
      this.trucks = false;
      this.drivers = false;
      this.orders = false;
      this.corporatecustomers = false;
      this.transporter = false;
      this.searchData = false;
      this.reportCloseWorkOrders = false;
      this.workorder_fetch_page = 1;
      this.workStartPage = 1;
      this.workOrdersReports = true;
      this.workorderloading = true;
      this.dri = false;
      this.driReport = false;
      this.advancedWorkOrders = true;
      this.workorders = true;
      this.preOrderReports = false;
      this.preOrderReports1 = false;
      this.pre_orders = false;

      this.workordersReports(
        this.fromDate,
        this.toDate,
        this.salesOrderNo,
        this.workorder_no,
        this.download,
        this.customerName,
        this.perPage,
        this.workStartPage
      );
    }

    if (this.report_type == "preorders") {
      this.document_array = [];
      this.selectedPreOrderId = -1;
      this.download = -1;
      this.resetPreOrder();
      this.todo = false;
      this.quotes = false;
      this.trips = false;
      this.payments = false;
      this.trucks = false;
      this.drivers = false;
      this.orders = false;
      this.corporatecustomers = false;
      this.transporter = false;
      this.searchData = false;
      this.reportCloseWorkOrders = false;
      this.pre_order_fetch_page = 1;
      this.preOrderStartPage = 1;
      this.workOrdersReports = false;
      this.preOrderReports = true;
      this.preOrderReports1 = false;
      this.preorderLoading = true;
      this.advancedWorkOrders = true;
      this.workorders = false;
      this.pre_orders = true;
      this.pre_orders_2 = false;
      this.dri = false;
      this.driReport = false;

      this.preordersReports(
        this.fromLocation,
        this.toLocation,
        this.fromDate,
        this.toDate,
        this.truckCategory,
        this.download,
        this.woid,
        this.perPage,
        this.page
      );

      // Initially disable the `to_date` field
      this.pre_orderForm.get("toDate")?.disable();

      // Listen for user interaction with `from_date` to enable `to_date`
      this.pre_orderForm
        .get("fromDate")
        ?.valueChanges.subscribe((fromDateValue) => {
          if (fromDateValue) {
            this.pre_orderForm.get("toDate")?.enable();
          } else {
            this.pre_orderForm.get("toDate")?.disable();
          }
        });
    }

    if (this.report_type == "dri") {
      this.document_array = [];
      this.download = -1;
      this.resetDRI();
      this.todo = false;
      this.quotes = false;
      this.trips = false;
      this.payments = false;
      this.trucks = false;
      this.drivers = false;
      this.orders = false;
      this.corporatecustomers = false;
      this.transporter = false;
      this.searchData = false;
      this.reportCloseDRI = false;
      this.dri_fetch_page = 1;
      this.driStartPage = 1;
      this.sortColumn = "";
      this.sortDirection = "asc";
      this.driReport = true;
      this.driloading = true;
      this.advancedDRI = true;
      this.dri = true;
      this.preOrderReports = false;
      this.preOrderReports1 = false;
      this.pre_orders = false;
      this.workorders = false;

      this.driReports(
        this.driForm.value.from_city,
        this.driForm.value.to_city,
        this.driForm.value.from_date,
        this.driForm.value.to_date,
        this.driForm.value.truck_type,
        this.driForm.value.route_type,
        this.driForm.value.min_fare,
        this.driForm.value.max_fare,
        this.download,
        this.perPage,
        this.driStartPage
      );
    }
  }

  public advanceSearch() {
    this.SearchEnabled = true;
  }

  public close() {
    this.SearchEnabled = false;
  }

  reportadvanced(event: any) {
    this.isSearching = true;
    this.searchData = true;
    this.isApplyButtonDisabled = false;
    this.isSearchDisabled = true;
    if (event === "todo") {
      this.resetTodo();
      if (this.newid) {
        this.newid.nativeElement.value = "";
      }
      this.todoReport = true;
      this.advancedTodo = false;
      this.reportCloseTodo = true;
    }
    if (event === "quotes") {
      if (this.newItem) {
        this.newItem.nativeElement.value = "";
      }
      this.resetQuotes();
      this.quotesReport = true;
      this.advancedQuotes = false;
      this.reportCloseQuote = true;
    }
    if (event === "trips") {
      if (this.tripsTab) {
        this.tripsTab.nativeElement.value = "";
      }
      this.resetTrips();
      this.tripsReport = true;
      this.advancedTrips = false;
      this.reportCloseTrips = true;
    }
    if (event === "payments") {
      if (this.paymentTab) {
        this.paymentTab.nativeElement.value = "";
      }
      this.paymentReset();
      this.advancedPayments = false;
      this.reportClosePayments = true;
      this.paymentsReport = true;
    }
    if (event === "trucks") {
      if (this.trucksTab) {
        this.trucksTab.nativeElement.value = "";
      }
      this.resetTrucks();
      this.advancedTrucks = false;
      this.reportCloseTrucks = true;
      this.TrucksReports = true;
    }
    if (event === "drivers") {
      if (this.driverTab) {
        this.driverTab.nativeElement.value = "";
      }
      this.driverReset();
      this.advancedDrivers = false;
      this.reportCloseDrivers = true;
      this.DriversReports = true;
    }
    if (event === "orders") {
      if (this.orderTab) {
        this.orderTab.nativeElement.value = "";
      }
      this.resetOrders();
      this.advancedOrders = false;
      this.reportCloseOrders = true;
      this.OrdersReports = true;
    }
    if (event === "corporatecustomers") {
      if (this.corporateTab) {
        this.corporateTab.nativeElement.value = "";
      }
      this.resetCustomer();
      this.advancedCustomers = false;
      this.reportCloseCustomers = true;
      this.customerReport = false;
      this.isNoRecordsFound = false;
    }
    if (event === "transporter") {
      if (this.transporterTab) {
        this.transporterTab.nativeElement.value = "";
      }
      this.transporterReset();
      this.advancedTransporter = false;
      this.reportCloseTransporters = true;
      this.transporterReport = true;
    }
    if (event === "workorders") {
      if (this.newItemWO) {
        this.newItemWO.nativeElement.value = "";
      }
      this.resetWorkOrder();
      this.advancedWorkOrders = false;
      this.reportCloseWorkOrders = true;
      this.workOrdersReports = true;
    }
    if (event === "dri") {
      if (this.driTab) {
        this.driTab.nativeElement.value = "";
      }
      this.resetDRI();
      this.advancedDRI = false;
      this.reportCloseDRI = true;
      this.driReport = true;
    }
  }

  reportClose(event: any) {
    this.isApplyButtonDisabled = false;
    this.isSearchDisabled = false;
    this.searchData = false;
    this.isNoDataFound = false;
    this.isSearching = true;
    this.page = 1;
    this.fetch_page = 1;
    if (event === "todo") {
      this.resetTodo();
      if (this.reportCloseTodo == true) {
        this.advancedTodo = true;
        this.reportCloseTodo = false;
      }
    }
    if (event === "quotes") {
      this.resetQuotes();
      if (this.reportCloseQuote == true) {
        this.advancedQuotes = true;
        this.reportCloseQuote = false;
      }
    }
    if (event === "trips") {
      this.resetTrips();
      if (this.reportCloseTrips == true) {
        this.advancedTrips = true;
        this.reportCloseTrips = false;
      }
    }
    if (event === "payments") {
      this.paymentReset();
      if (this.reportClosePayments == true) {
        this.advancedPayments = true;
        this.reportClosePayments = false;
      }
    }
    if (event === "trucks") {
      this.resetTrucks();
      if (this.reportCloseTrucks == true) {
        this.advancedTrucks = true;
        this.reportCloseTrucks = false;
      }
    }
    if (event === "drivers") {
      this.driverReset();
      if (this.reportCloseDrivers == true) {
        this.advancedDrivers = true;
        this.reportCloseDrivers = false;
      }
    }
    if (event === "orders") {
      this.resetOrders();
      if (this.reportCloseOrders == true) {
        this.advancedOrders = true;
        this.reportCloseOrders = false;
      }
    }
    if (event === "transporter") {
      this.transporterReset();
      if (this.reportCloseTransporters == true) {
        this.advancedTransporter = true;
        this.reportCloseTransporters = false;
      }
    }
    if (event === "workorders") {
      this.resetWorkOrder();
      if (this.reportCloseWorkOrders == true) {
        this.advancedWorkOrders = true;
        this.reportCloseWorkOrders = false;
      }
    }
    if (event === "dri") {
      this.resetDRI();
      if (this.reportCloseDRI == true) {
        this.advancedDRI = true;
        this.reportCloseDRI = false;
      }
    }
  }

  corporateCustomerClose() {
    this.isApplyButtonDisabled = false;
    this.isSearchDisabled = false;
    this.reportCloseCustomers = false;
    this.searchData = false;
    this.advancedCustomers = true;
    this.customerStartPage;
    this.customerDetailsEnable = true;
    this.isNoRecordsFound = false;
    this.customer(
      this.fromDate,
      this.toDate,
      this.fromLocation,
      this.toLocation,
      this.salesOrderNo,
      this.workOrderNo,
      this.tripId,
      this.lrNo,
      this.vchlNo,
      this.download,
      this.perPage,
      this.customerStartPage
    );
  }

  getAllList() {
    this.services.GetMasterList(this.token).subscribe(
      (list: any) => {
        this.masterList = list.body.data;
        if (this.masterList.tripNumbers) {
          this.masterList.tripNumbers = this.masterList.tripNumbers
            .map((trip: any) => {
              const match = trip.match(/\d+/); // Extract numeric part
              const number = match ? parseInt(match[0], 10) : null; // Convert to number
              return { original: trip, number }; // Return an object with both original and number
            })
            .filter((item: any) => item.number !== null) // Filter out items without a valid number
            .sort((a: any, b: any) => b.number - a.number) // Sort in descending order based on number
            .map((item: any) => item.original); // Extract the original values after sorting
        }
        this.filteredTripStatus = this.masterList.trip_status.filter(
          (status: string) => status !== "quote"
        );
      },
      (error) => {
        if (error.error.message === "jwt malformed") {
          this.router.navigateByUrl("admin/login");
        }
        this.snackBar.open(error.error.message, "Fail", {
          duration: 5000,
        });
      }
    );
  }

  getMappingList() {
    this.services
      .GetMappingsList(
        this.token,
        this.searchTruckNumber,
        this.perPage,
        this.startPage
      )
      .subscribe(
        (list: any) => {
          this.mappingList = list.body.data;
          // this.document_array.push(list.body.meta);

          // this.last_page = list.body.meta.lastPage;
        },
        (error) => {
          if (error.status == 403) {
            this.router.navigateByUrl("admin/login");
            localStorage.clear();
          }
          if (error.error.message === "jwt malformed") {
            this.router.navigateByUrl("admin/login");
          }
          this.snackBar.open(error.error.message, "Fail", {
            duration: 5000,
          });
        }
      );
  }

  tododownloadXl(tododownloadArray: string) {
    // Get date values from form
    const fromDateValue = this.todoForm.value.from_date;
    const toDateValue = this.todoForm.value.to_date;

    // Initialize formatted dates to -1
    let formattedFromDate = "-1";
    let formattedToDate = "-1";

    // Check if fromDateValue is valid and not empty
    if (fromDateValue) {
      const parsedFromDate = new Date(fromDateValue);
      if (!isNaN(parsedFromDate.getTime())) {
        formattedFromDate = formatDate(parsedFromDate, "yyyy-MM-dd", "en");
      }
    }

    // Check if toDateValue is valid and not empty
    if (toDateValue) {
      const parsedToDate = new Date(toDateValue);
      if (!isNaN(parsedToDate.getTime())) {
        formattedToDate = formatDate(parsedToDate, "yyyy-MM-dd", "en");
      }
    }
    if (tododownloadArray === "") {
      this.download = this.downloadQuotes;
      let from = "Download";
      this.todoReports(
        formattedFromDate,
        formattedToDate,
        this.todoForm.value.trip_status || this.tripStatus,
        this.todoForm.value.trip_id || this.tripId,
        this.todoForm.value.bank_name
          ? this.todoForm.value.bank_name
          : this.bankName,
        this.todoForm.value.truck_no || this.truckNo,
        this.download,
        this.perPage,
        this.page,
        from
      );
    } else {
      window.open(tododownloadArray, "_blank");
    }
  }

  tododownloadPdf(pdfArray: string) {
    if (pdfArray === "") {
      this.download = this.downloadQuotes;
      let from = "pdfDownload";
      this.todoReports(
        this.fromDate,
        this.toDate,
        this.tripStatus,
        this.tripId,
        this.bankName,
        this.truckNo,
        this.download,
        this.perPage,
        this.page,
        from
      );
    }
  }

  downloadXl(downloadArray: string) {
    const fromDateValue = this.quotesForm.value.from_date;
    const toDateValue = this.quotesForm.value.to_date;

    // Initialize formatted dates to -1
    let formattedFromDate = "-1";
    let formattedToDate = "-1";

    // Check if fromDateValue is valid and not empty
    if (fromDateValue) {
      const parsedFromDate = new Date(fromDateValue);
      if (!isNaN(parsedFromDate.getTime())) {
        formattedFromDate = formatDate(parsedFromDate, "yyyy-MM-dd", "en");
      }
    }

    // Check if toDateValue is valid and not empty
    if (toDateValue) {
      const parsedToDate = new Date(toDateValue);
      if (!isNaN(parsedToDate.getTime())) {
        formattedToDate = formatDate(parsedToDate, "yyyy-MM-dd", "en");
      }
    }
    if (downloadArray === "") {
      this.download = this.downloadQuotes;
      let from = "Download";
      // Get date values from form

      this.quotesReports(
        formattedFromDate || this.quotesForm.value.from_date,
        formattedToDate || this.quotesForm.value.to_date,
        this.quotesForm.value.from_loc || this.fromLocation,
        this.quotesForm.value.to_loc || this.toLocation,

        this.quotesForm.value.truck_categ || this.truckCategory,
        this.tripId,
        this.download,
        this.perPage,
        this.quoteStartPage,
        this.report_status,
        from
      );
    } else {
      window.open(downloadArray, "_blank");
    }
  }

  todoReports(
    fromDate: any,
    toDate: any,
    tripStatus: any,
    tripId: any,
    bankName: any,
    truckNo: any,
    download: any,
    perPage: any,
    page: any,
    from?: any
  ) {
    this.services
      .gettodoReports(
        this.token,
        fromDate,
        toDate,
        tripStatus,
        tripId,
        bankName,
        truckNo,
        download,
        perPage,
        this.todoStartPage
      )
      .subscribe(
        (response: any) => {
          this.todoArray = [];
          this.todoloading = false;
          this.todoloading = false;
          this.todoArray = response.body.data;
          this.document_array.push(response.body.meta);
          this.last_page = response.body.meta?.lastPage;
          this.tododownloadArray = response.body.url;

          if (from === "Download") {
            window.open(this.tododownloadArray, "_blank");
          }
          if (from === "pdfDownload") {
            const fileUrl =
              "https://s9trucks-dev.s3.us-east-2.amazonaws.com/S9_Admin_Report_1720098863040.csv";
            this.http
              .get(this.tododownloadArray, { responseType: "blob" })
              .subscribe((blob: Blob) => {
                const downloadLink = document.createElement("a");
                const url = window.URL.createObjectURL(blob);
                downloadLink.href = url;
                downloadLink.download = "S9_Admin_Report.pdf";
                document.body.appendChild(downloadLink);
                downloadLink.click();
                document.body.removeChild(downloadLink);
                window.URL.revokeObjectURL(url);
              });
          }
        },
        (error) => {
          if (error.error.message === "jwt malformed") {
            this.router.navigateByUrl("admin/login");
            window.localStorage.clear();
          }
          if (error.error.message === "jwt expired") {
            this.router.navigateByUrl("admin/login");
            window.localStorage.clear();
          }
          if (error.error.message === "invalid signature") {
            this.router.navigateByUrl("admin/login");
            window.localStorage.clear();
          }
          if (error.error.message === "No record found") {
            this.isNoDataFound = true;
            this.todoArray = [];
            this.todoReport = false;
            this.isApplyButtonDisabled = true;
          } else {
            this.isApplyButtonDisabled = false;
          }
          this.snackBar.open(error.error.message, "Fail", {
            duration: 5000,
          });
        }
      );
  }
  todopagination(page_status: any) {
    // this.document_array = [];
    if (page_status == "-1") {
      this.todo_fetch_page = parseInt(this.todo_fetch_page) - 1;
      this.currentPage = this.todo_fetch_page;
      this.todoStartPage = this.currentPage;
    }
    if (page_status == "1") {
      this.currentPage = parseInt(this.todo_fetch_page) + 1;
      this.todo_fetch_page = this.currentPage;
      this.todoStartPage = this.todo_fetch_page;
    }
    if (page_status == "first") {
      this.todo_fetch_page = this.document_array[0].currentPage;
      this.todoStartPage = this.document_array[0].currentPage;
    }
    if (page_status == "last") {
      this.todo_fetch_page = this.document_array[0].lastPage;
      this.todoStartPage = this.document_array[0].lastPage;
    }
    // Get date values from form
    const fromDateValue = this.todoForm.value.from_date;
    const toDateValue = this.todoForm.value.to_date;

    // Initialize formatted dates to -1
    let formattedFromDate = "-1";
    let formattedToDate = "-1";

    // Check if fromDateValue is valid and not empty
    if (fromDateValue) {
      const parsedFromDate = new Date(fromDateValue);
      if (!isNaN(parsedFromDate.getTime())) {
        formattedFromDate = formatDate(parsedFromDate, "yyyy-MM-dd", "en");
      }
    }

    // Check if toDateValue is valid and not empty
    if (toDateValue) {
      const parsedToDate = new Date(toDateValue);
      if (!isNaN(parsedToDate.getTime())) {
        formattedToDate = formatDate(parsedToDate, "yyyy-MM-dd", "en");
      }
    }

    this.todoReports(
      formattedFromDate,
      formattedToDate,
      this.todoForm.value.trip_status || this.tripStatus,
      this.todoForm.value.trip_id || this.tripId,
      this.todoForm.value.bank_name
        ? this.todoForm.value.bank_name
        : this.bankName,
      this.todoForm.value.truck_no || this.truckNo,
      this.download,
      this.perPage,
      this.paginationNumber
    );
  }

  quotesReports(
    fromDate: any,
    toDate: any,
    fromLocation: any,
    toLocation: any,
    truckCategory: any,
    tripId: any,
    download: any,
    perPage: any,
    page: any,
    report_status: any,
    from?: any
  ) {
    this.quotesloading = true;
    this.quotesArray = [];
    this.services
      .getReports(
        this.token,
        fromLocation,
        toLocation,
        fromDate,
        toDate,
        truckCategory,
        tripId,
        download,
        perPage,
        this.quoteStartPage,
        report_status
      )
      .subscribe(
        (response: any) => {
          this.quotesloading = false;
          this.quotesArray = response.body.data;
          this.document_array.push(response.body.meta);
          this.last_page = response.body?.meta?.lastPage;
          this.downloadArray = response.body.url;
          if (from === "Download") {
            window.open(this.downloadArray, "_blank");
          }
        },
        (error) => {
          this.quotesloading = false;
          this.last_page = 0;
          if (error.error.message === "jwt malformed") {
            this.router.navigateByUrl("admin/login");
            window.localStorage.clear();
          }
          if (error.error.message === "jwt expired") {
            this.router.navigateByUrl("admin/login");
            window.localStorage.clear();
          }
          if (error.error.message === "invalid signature") {
            this.router.navigateByUrl("admin/login");
            window.localStorage.clear();
          }
          if (error.error.message === "No record found") {
            this.isNoDataFound = true;
            this.quotesArray = [];
            this.quotesReport = false;
            this.isApplyButtonDisabled = true;
          } else {
            this.isApplyButtonDisabled = false;
          }

          this.snackBar.open(error.error.message, "Fail", {
            duration: 5000,
          });
        }
      );
  }

  quotespagination(page_status: any) {
    if (page_status == "-1") {
      this.fetch_page = parseInt(this.fetch_page) - 1;
      this.currentPage = this.fetch_page;
      this.quoteStartPage = this.currentPage;
    }
    if (page_status == "1") {
      this.currentPage = parseInt(this.fetch_page) + 1;
      this.fetch_page = this.currentPage;
      this.quoteStartPage = this.fetch_page;
    }
    if (page_status == "first") {
      this.fetch_page = this.document_array[0].currentPage;
      this.quoteStartPage = this.document_array[0].currentPage;
    }
    if (page_status == "last") {
      this.fetch_page = this.document_array[0].lastPage;
      this.quoteStartPage = this.document_array[0].lastPage;
    }

    // Get date values from form
    const fromDateValue = this.quotesForm.value.from_date;
    const toDateValue = this.quotesForm.value.to_date;

    // Initialize formatted dates to -1
    let formattedFromDate = "-1";
    let formattedToDate = "-1";

    // Check if fromDateValue is valid and not empty
    if (fromDateValue) {
      const parsedFromDate = new Date(fromDateValue);
      if (!isNaN(parsedFromDate.getTime())) {
        formattedFromDate = formatDate(parsedFromDate, "yyyy-MM-dd", "en");
      }
    }

    // Check if toDateValue is valid and not empty
    if (toDateValue) {
      const parsedToDate = new Date(toDateValue);
      if (!isNaN(parsedToDate.getTime())) {
        formattedToDate = formatDate(parsedToDate, "yyyy-MM-dd", "en");
      }
    }

    this.quotesReports(
      this.quotesForm.value.from_date || formattedFromDate,
      this.quotesForm.value.to_date || formattedToDate,
      this.quotesForm.value.from_loc || this.fromLocation,
      this.quotesForm.value.to_loc || this.toLocation,
      this.quotesForm.value.truck_categ || this.truckCategory,
      this.tripId,
      this.download,
      this.perPage,
      this.quoteStartPage,
      this.report_status
    );
  }

  paymentsReports(
    fromLocation: any,
    toLocation: any,
    fromDate: any,
    toDate: any,
    status: any,
    tripId: any,
    download: any,
    perPage: any,
    paymentPage: any,
    from?: any
  ) {
    this.paymentsloading = true;
    this.paymentsArray = [];
    this.services
      .getpaymentsReports(
        this.token,
        fromLocation,
        toLocation,
        fromDate,
        toDate,
        status,
        tripId,
        download,
        perPage,
        this.paymentStartPage
      )
      .subscribe(
        (response: any) => {
          this.paymentsloading = false;
          this.paymentsArray = response.body.data;
          this.document_array.push(response.body.meta);
          this.last_page = response.body.meta?.lastPage;
          this.paymentdownloadArray = response.body.url;
          if (from === "Download") {
            window.open(this.paymentdownloadArray, "_blank");
          }
          for (let i = 0; i < this.paymentsArray.length; i++) {
            if (this.paymentsArray[i].tax_type == "percent") {
              this.totalTax +=
                (this.paymentsArray[i].tax_deduction / 100) *
                this.totalReceivable;
            } else {
              this.totalTax += this.paymentsArray[i].tax_deduction;
            }
          }
        },
        (error) => {
          this.paymentsloading = false;
          if (error.error.message === "jwt malformed") {
            this.router.navigateByUrl("admin/login");
            window.localStorage.clear();
          }
          if (error.error.message === "jwt expired") {
            this.router.navigateByUrl("admin/login");
            window.localStorage.clear();
          }
          if (error.error.message === "invalid signature") {
            this.router.navigateByUrl("admin/login");
            window.localStorage.clear();
          }

          if (error.error.message === "No records found") {
            this.isNoDataFound = true;
            this.paymentsArray = [];
            this.paymentsReport = false;
            this.isApplyButtonDisabled = true;
          } else {
            this.isApplyButtonDisabled = false;
          }
          this.snackBar.open(error.error.message, "Fail", {
            duration: 5000,
          });
        }
      );
  }

  paymentsHeader() {
    this.services.getpaymentDetails(this.token).subscribe((response: any) => {
      this.paymentData = response.body.data;
      this.paymentsGst();
      this.paymentTransGet();
    });
  }
  paymentsGst() {
    this.customer_total_receivable =
      this.paymentData?.customer_payments.total_receivable;
    this.totalAmount = this.customer_total_receivable;
    this.round_amount = this.totalAmount;
    this.services.getpaymentlist(this.token).subscribe((response: any) => {
      this.paymentGst = response.body.data;
      for (let i = 0; i < this.paymentGst.length; i++) {
        this.tax_details.push({
          tax_name: this.paymentGst[i].tax_name,
          tax_type: this.paymentGst[i].tax_type,
          tax_deduction: this.paymentGst[i].tax_deduction,
        });
        if (this.paymentGst[i].tax_type == "percent") {
          this.totalAmount =
            this.totalAmount +
            (this.customer_total_receivable *
              this.paymentGst[i].tax_deduction) /
            100;
          this.round_amount = Math.round(this.totalAmount);
        } else {
          this.totalAmount =
            this.totalAmount - this.paymentGst[i].tax_deduction;
        }
      }
      this.paynowAmt = this.totalAmount * (12 / 100);
      this.round_payamount = Math.round(this.paynowAmt);
    });
  }
  paymentTransGet() {
    this.trans_total_receivable =
      this.paymentData?.truckowner_payments.total_receivable;
    this.trans_round_amount = this.trans_total_receivable;
    this.trans_round_amount = this.trans_round_amount;
    this.services.getpaymentlists(this.token).subscribe((response: any) => {
      this.paymnetTransGST = response.body.data;

      for (let i = 0; i < this.paymnetTransGST.length; i++) {
        this.tax_details.push({
          tax_name: this.paymnetTransGST[i].tax_name,
          tax_type: this.paymnetTransGST[i].tax_type,
          tax_deduction: this.paymnetTransGST[i].tax_deduction,
        });
        if (this.paymnetTransGST[i].tax_type == "percent") {
          this.trans_round_amount =
            this.trans_round_amount +
            (this.trans_total_receivable *
              this.paymnetTransGST[i].tax_deduction) /
            100;
          this.trans_round_amount = Math.round(this.trans_round_amount);
        } else {
          this.trans_round_amount =
            this.trans_round_amount - this.paymnetTransGST[i].tax_deduction;
        }
      }
      this.paynowAmt = this.trans_round_amount * (12 / 100);
      this.round_payamount = Math.round(this.paynowAmt);
    });
  }

  paymentspagination(page_status: any) {
    if (page_status == "-1") {
      this.payment_fetch_page = parseInt(this.payment_fetch_page) - 1;
      this.currentPage = this.payment_fetch_page;
      this.paymentStartPage = this.currentPage;
    }
    if (page_status == "1") {
      this.currentPage = parseInt(this.payment_fetch_page) + 1;
      this.payment_fetch_page = this.currentPage;
      this.paymentStartPage = this.payment_fetch_page;
    }
    if (page_status == "first") {
      this.payment_fetch_page = this.document_array[0].currentPage;
      this.paymentStartPage = this.document_array[0].currentPage;
    }
    if (page_status == "last") {
      this.payment_fetch_page = this.document_array[0].lastPage;
      this.paymentStartPage = this.document_array[0].lastPage;
    }

    // Get date values from form
    const fromDateValue = this.paymentsForm.value.from_date;
    const toDateValue = this.paymentsForm.value.to_date;

    // Initialize formatted dates to -1
    let formattedFromDate = "-1";
    let formattedToDate = "-1";

    // Check if fromDateValue is valid and not empty
    if (fromDateValue) {
      const parsedFromDate = new Date(fromDateValue);
      if (!isNaN(parsedFromDate.getTime())) {
        formattedFromDate = formatDate(parsedFromDate, "yyyy-MM-dd", "en");
      }
    }

    // Check if toDateValue is valid and not empty
    if (toDateValue) {
      const parsedToDate = new Date(toDateValue);
      if (!isNaN(parsedToDate.getTime())) {
        formattedToDate = formatDate(parsedToDate, "yyyy-MM-dd", "en");
      }
    }
    this.paymentsReports(
      this.paymentsForm.value.from_loc || this.fromLocation,
      this.paymentsForm.value.to_loc || this.toLocation,
      formattedFromDate,
      formattedToDate,
      this.paymentsForm.value.payment_status || this.paymentStatus,
      this.paymentsForm.value.trip_id || this.tripId,
      this.download,
      this.perPage,
      this.paymentStartPage
    );
  }

  tripsReports(
    fromLocation: any,
    toLocation: any,
    fromDate: any,
    toDate: any,
    truckCategory: any,
    truckWeight: any,
    vehicleNumber: any,
    tripId: any,
    tripStatus: any,
    download: any,
    perPage: any,
    page: any,
    from?: any
  ) {
    this.tripsArray = [];
    this.tripsloading = true;
    this.services
      .gettripsReports(
        this.token,
        fromLocation,
        toLocation,
        fromDate,
        toDate,
        truckCategory,
        truckWeight,
        this.tripsForm.value.vehcl_no || this.vehicleNumber,
        tripId,
        tripStatus,
        download,
        perPage,
        this.tripsStartPage
      )
      .subscribe(
        (response: any) => {
          this.tripsloading = false;
          this.tripsArray = response.body.data;
          this.document_array.push(response.body.meta);
          this.last_page = response.body.meta?.lastPage;
          this.tripsdownloadArray = response.body.url;
          if (this.tripsArray == 0) {
            this.snackBar.open("No Record Found", "Fail", {
              duration: 5000,
            });
            this.isApplyButtonDisabled = true;
          } else {
            this.isApplyButtonDisabled = false;
          }
          if (from === "Download") {
            window.open(this.tripsdownloadArray, "_blank");
          }
        },
        (error) => {
          if (error.error.message === "jwt malformed") {
            this.router.navigateByUrl("admin/login");
            window.localStorage.clear();
          }
          if (error.error.message === "jwt expired") {
            this.router.navigateByUrl("admin/login");
            window.localStorage.clear();
          }
          if (error.error.message === "invalid signature") {
            this.router.navigateByUrl("admin/login");
            window.localStorage.clear();
          }
          if (error.error.message === "No Record Found") {
            this.isNoDataFound = true;
            this.tripsArray = [];
            this.tripsReport = false;
            this.isApplyButtonDisabled = true;
          } else {
            this.isApplyButtonDisabled = false;
          }
          this.snackBar.open(error.error.message, "Fail", {
            duration: 5000,
          });
        }
      );
  }

  driverdownloadXl(driversdownloadArray: string) {
    if (driversdownloadArray === "") {
      this.download = this.downloadQuotes;
      let from = "Download";
      this.driversReports(
        this.driversForm.value.truckNumber || this.truckNo,
        this.truckOwnerName,
        this.driversForm.value.driverStatus || this.driverStatus,
        this.download,
        this.driverIdKeyword || this.driverName,
        this.driver_status,
        this.perPage,
        this.page,
        from
      );
    } else {
      window.open(driversdownloadArray, "_blank");
    }
  }

  paymentdownloadXl(paymentdownloadArray: string) {
    if (paymentdownloadArray === "") {
      this.download = this.downloadQuotes;
      let from = "Download";
      this.paymentsReports(
        this.fromLocation,
        this.toLocation,
        this.fromDate,
        this.toDate,
        this.paymentStatus,
        this.tripId,
        this.download,
        this.perPage,
        this.paymentPage,
        from
      );
    } else {
      window.open(paymentdownloadArray, "_blank");
    }
  }

  driversReports(
    truckNo: any,
    truckOwnerName: any,
    driverStatus: any,
    download: any,
    driverName: any,
    driver_status: any,
    perPage: any,
    page: any,
    from?: any
  ) {
    this.driversArray = [];
    this.driversloading = true;

    this.services
      .getDriversReports(
        this.token,
        truckNo,
        truckOwnerName,
        driverStatus,
        download,
        driverName,
        driver_status,
        perPage,
        this.driverStartPage
      )
      .subscribe(
        (response: any) => {
          this.driversloading = false;
          this.driversArray = response.body.data;
          this.document_array.push(response.body.meta);
          this.last_page = response.body.meta?.lastPage;
          this.driversdownloadArray = response.body.url;
          if (from === "Download") {
            window.open(this.driversdownloadArray, "_blank");
          }
        },
        (error) => {
          this.driversloading = false;
          this.last_page = 0;

          if (error.error.message === "jwt malformed") {
            this.router.navigateByUrl("admin/login");
            window.localStorage.clear();
          }
          if (error.error.message === "jwt expired") {
            this.router.navigateByUrl("admin/login");
            window.localStorage.clear();
          }
          if (error.error.message === "invalid signature") {
            this.router.navigateByUrl("admin/login");
            window.localStorage.clear();
          }
          if (error.error.message === "No record found") {
            this.isNoDataFound = true;
            this.driversArray = [];
            this.DriversReports = false;
            this.driversloading = false;
            this.isApplyButtonDisabled = true;
          } else {
            this.isApplyButtonDisabled = false;
          }
          this.snackBar.open(error.error.message, "Fail", {
            duration: 5000,
          });
        }
      );
  }

  driverspagination(page_status: any) {
    if (page_status == "-1") {
      this.drivers_fetch_page = parseInt(this.drivers_fetch_page) - 1;
      this.currentPage = this.drivers_fetch_page;
      this.driverStartPage = this.currentPage;
    }
    if (page_status == "1") {
      this.currentPage = parseInt(this.drivers_fetch_page) + 1;
      this.drivers_fetch_page = this.currentPage;
      this.driverStartPage = this.drivers_fetch_page;
    }
    if (page_status == "first") {
      this.document_array[0].currentPage = 1;
      this.drivers_fetch_page = this.document_array[0].currentPage;
      this.driverStartPage = this.document_array[0].currentPage;
    }
    if (page_status == "last") {
      this.drivers_fetch_page = this.document_array[0].lastPage;
      this.driverStartPage = this.document_array[0].lastPage;
    }
    this.driversReports(
      this.driversForm.value.truckNumber || this.truckNo,
      this.truckOwnerName,
      this.driversForm.value.driverStatus || this.driverStatus,
      this.download,
      this.driverName,
      this.driver_status,
      this.perPage,
      this.driverStartPage
    );
  }

  transporterReports(
    salesOrderNo: any,
    workOrderNo: any,
    truckOwnerName: any,
    truckNo: any,
    fromDate: any,
    toDate: any,
    download: any,
    tripId: any,
    perPage: any,
    page: any,
    from?: any
  ) {
    this.transporterArray = [];
    this.transporterloading = true;
    this.services
      .getTransporterReports(
        this.token,
        salesOrderNo,
        workOrderNo,
        truckOwnerName,
        truckNo,
        fromDate,
        toDate,
        download,

        tripId,
        perPage,
        this.transportStartPage
      )
      .subscribe(
        (response: any) => {
          this.transporterloading = false;
          this.transporterArray = response.body.data;
          this.document_array.push(response.body.meta);
          this.last_page = response.body.meta?.lastPage;
          this.transporterdownloadArray = response.body.url;
          if (from === "Download") {
            window.open(this.transporterdownloadArray, "_blank");
          }
        },
        (error) => {
          this.transporterloading = false;

          if (error.error.message === "jwt malformed") {
            this.router.navigateByUrl("admin/login");
            window.localStorage.clear();
          }
          if (error.error.message === "jwt expired") {
            this.router.navigateByUrl("admin/login");
            window.localStorage.clear();
          }
          if (error.error.message === "invalid signature") {
            this.router.navigateByUrl("admin/login");
            window.localStorage.clear();
          }
          if (error.error.message === "No record found") {
            this.isNoDataFound = true;
            this.transporterArray = [];
            this.transporterReport = false;
            this.isApplyButtonDisabled = true;
          } else {
            this.isApplyButtonDisabled = false;
          }
          this.snackBar.open(error.error.message, "Fail", {
            duration: 5000,
          });
        }
      );
  }

  transporterpagination(page_status: any) {
    if (page_status == "-1") {
      this.transport_fetch_page = parseInt(this.transport_fetch_page) - 1;
      this.currentPage = this.transport_fetch_page;
      this.transportStartPage = this.currentPage;
    }
    if (page_status == "1") {
      this.currentPage = parseInt(this.transport_fetch_page) + 1;
      this.transport_fetch_page = this.currentPage;
      this.transportStartPage = this.transport_fetch_page;
    }
    if (page_status == "first") {
      this.transport_fetch_page = this.document_array[0].currentPage;
      this.transportStartPage = this.document_array[0].currentPage;
    }
    if (page_status == "last") {
      this.transport_fetch_page = this.document_array[0].lastPage;
      this.transportStartPage = this.document_array[0].lastPage;
    }

    // Get date values from form
    const fromDateValue = this.transportForm.value.from_date;
    const toDateValue = this.transportForm.value.to_date;

    // Initialize formatted dates to -1
    let formattedFromDate = "-1";
    let formattedToDate = "-1";

    // Check if fromDateValue is valid and not empty
    if (fromDateValue) {
      const parsedFromDate = new Date(fromDateValue);
      if (!isNaN(parsedFromDate.getTime())) {
        formattedFromDate = formatDate(parsedFromDate, "yyyy-MM-dd", "en");
      }
    }

    // Check if toDateValue is valid and not empty
    if (toDateValue) {
      const parsedToDate = new Date(toDateValue);
      if (!isNaN(parsedToDate.getTime())) {
        formattedToDate = formatDate(parsedToDate, "yyyy-MM-dd", "en");
      }
    }
    this.transporterReports(
      this.transportForm.value.sales_order || this.salesOrderNo,
      this.workOrderNo,
      this.transporterIdKeyword ||
      this.transportForm.value.truckowner_name ||
      this.truckOwnerName,
      this.truckNo,
      formattedFromDate,
      formattedToDate,
      this.transportForm.value.trip_id || this.tripId,
      this.download,
      this.perPage,
      this.transportStartPage
    );
  }

  truckdownloadXl(trucksdownloadArray: string) {
    if (trucksdownloadArray === "") {
      this.download = this.downloadQuotes;
      let from = "Download";
      this.trucksReports(
        this.fromLocation,
        this.toLocation,
        this.fromDate,
        this.toDate,
        this.trucksForm.value.veh_cat || this.truckCategory,
        this.trucksForm.value.feet || this.truckFeet,
        this.trucksForm.value.weight || this.truckWeight,
        this.trucksForm.value.veh_status || this.vehicleStatus,
        this.trucksForm.value.truckowner_name || this.truckOwner,
        this.download,
        this.truckNumber,
        this.perPage,
        this.page,
        from
      );
    } else {
      window.open(trucksdownloadArray, "_blank");
    }
  }

  trucksReports(
    fromLocation: any,
    toLocation: any,
    fromDate: any,
    toDate: any,
    truckCategory: any,
    truckFeet: any,
    truckWeight: any,
    vehicleStatus: any,
    truckOwner: any,
    download: any,
    truckNumber: any,
    perPage: any,
    page: any,
    from?: any
  ) {
    this.tripsArray = [];
    this.trucksloading = true;

    this.services
      .getTrucksReports(
        this.token,
        fromLocation,
        toLocation,
        fromDate,
        toDate,
        truckCategory,
        truckFeet,
        truckWeight,
        vehicleStatus,
        truckOwner,
        download,
        truckNumber,
        perPage,
        this.truckStartPage
      )
      .subscribe(
        (response: any) => {
          this.trucksloading = false;
          this.truckArray = response.body.data;
          this.document_array.push(response.body.meta);
          this.last_page = response.body.meta?.lastPage;
          this.trucksdownloadArray = response.body.url;
          if (from === "Download") {
            window.open(this.trucksdownloadArray, "_blank");
          }
        },
        (error) => {
          this.trucksloading = false;
          if (error.error.message === "jwt malformed") {
            this.router.navigateByUrl("admin/login");
            window.localStorage.clear();
          }
          if (error.error.message === "jwt expired") {
            this.router.navigateByUrl("admin/login");
            window.localStorage.clear();
          }
          if (error.error.message === "invalid signature") {
            this.router.navigateByUrl("admin/login");
            window.localStorage.clear();
          }

          if (error.error.message === "No record found") {
            this.isNoDataFound = true;
            this.truckArray = [];
            this.TrucksReports = false;
            this.trucksloading = false;
            this.isApplyButtonDisabled = true;
          } else {
            this.isApplyButtonDisabled = false;
          }
          this.snackBar.open(error.error.message, "Fail", {
            duration: 5000,
          });
        }
      );
  }
  truckspagination(page_status: any) {
    if (page_status == "-1") {
      this.truck_fetch_page = parseInt(this.truck_fetch_page) - 1;
      this.currentPage = this.fetch_page;
      this.truckStartPage = this.currentPage;
    }
    if (page_status == "1") {
      this.currentPage = parseInt(this.truck_fetch_page) + 1;
      this.truck_fetch_page = this.currentPage;
      this.truckStartPage = this.truck_fetch_page;
    }
    if (page_status == "first") {
      this.truck_fetch_page = this.document_array[0].currentPage;
      this.truckStartPage = this.document_array[0].currentPage;
      this.truck_fetch_page = 1;
      this.truckStartPage = 1;
    }
    if (page_status == "last") {
      this.truck_fetch_page = this.document_array[0].lastPage;
      this.truckStartPage = this.document_array[0].lastPage;
    }

    this.trucksReports(
      this.fromLocation,
      this.toLocation,
      this.fromDate,
      this.toDate,
      this.trucksForm.value.veh_cat || this.truckCategory,
      this.trucksForm.value.veh_feet || this.truckFeet,
      this.trucksForm.value.weight || this.truckWeight,
      this.trucksForm.value.veh_status || this.vehicleStatus,
      this.trucksForm.value.truckowner_name || this.truckOwner,
      this.download,
      this.truckNumber,
      this.perPage,
      this.truckStartPage,
      this.report_status
    );
  }

  orderdownloadXl(ordersdownloadArray: string) {
    // Get date values from form
    const fromDateValue = this.ordersForm.value.from_date;
    const toDateValue = this.ordersForm.value.to_date;

    // Initialize formatted dates to -1
    let formattedFromDate = "-1";
    let formattedToDate = "-1";

    // Check if fromDateValue is valid and not empty
    if (fromDateValue) {
      const parsedFromDate = new Date(fromDateValue);
      if (!isNaN(parsedFromDate.getTime())) {
        formattedFromDate = formatDate(parsedFromDate, "yyyy-MM-dd", "en");
      }
    }

    // Check if toDateValue is valid and not empty
    if (toDateValue) {
      const parsedToDate = new Date(toDateValue);
      if (!isNaN(parsedToDate.getTime())) {
        formattedToDate = formatDate(parsedToDate, "yyyy-MM-dd", "en");
      }
    }
    if (ordersdownloadArray === "") {
      this.download = this.downloadQuotes;
      let from = "Download";
      this.ordersStartPage = 1;
      this.ordersReports(
        this.ordersForm.value.from_loc || this.fromLocation,
        this.ordersForm.value.to_loc || this.toLocation,
        fromDateValue || this.fromDate,
        toDateValue || this.toDate,
        this.ordersForm.value.veh_cat || this.truckCategory,
        this.ordersForm.value.trip_id || this.tripId,
        this.ordersForm.value.weight || this.truckWeight,
        this.orderStatus,
        this.ordersForm.value.truckowner_name || this.truckOwner,
        this.download,
        this.perPage,
        this.page,
        from
      );
    } else {
      window.open(ordersdownloadArray, "_blank");
    }
  }
  ordersReports(
    fromLocation: any,
    toLocation: any,
    fromDate: any,
    toDate: any,
    truckCategory: any,
    tripId: any,
    truckWeight: any,
    orderStatus: any,
    truckOwner: any,
    download: any,
    perPage: any,
    page: any,
    from?: any
  ) {
    this.ordersloading = true;
    this.ordersArray = [];
    this.services
      .getOrdersReports(
        this.token,
        fromLocation,
        toLocation,
        fromDate,
        toDate,
        truckCategory,
        tripId,
        truckWeight,
        orderStatus,
        truckOwner,
        download,
        perPage,
        this.ordersStartPage
      )
      .subscribe(
        (response: any) => {
          this.ordersloading = false;
          this.ordersArray = response.body.data;
          this.document_array.push(response.body.meta);
          this.last_page = response.body.meta?.lastPage;
          this.ordersdownloadArray = response.body.url;
          if (from === "Download") {
            window.open(this.ordersdownloadArray, "_blank");
          }
        },
        (error) => {
          if (error.error.message === "jwt malformed") {
            this.router.navigateByUrl("admin/login");
            window.localStorage.clear();
          }
          if (error.error.message === "jwt expired") {
            this.router.navigateByUrl("admin/login");
            window.localStorage.clear();
          }
          if (error.error.message === "invalid signature") {
            this.router.navigateByUrl("admin/login");
            window.localStorage.clear();
          }
          if (error.error.message === "No record found") {
            this.isNoDataFound = true;
            this.ordersArray = [];
            this.OrdersReports = false;
            this.ordersloading = false;
            this.isApplyButtonDisabled = true;
          } else {
            this.isApplyButtonDisabled = false;
          }
          this.snackBar.open(error.error.message, "Fail", {
            duration: 5000,
          });
        }
      );
  }
  orderspagination(page_status: any) {
    if (page_status == "-1") {
      this.orders_fetch_page = parseInt(this.orders_fetch_page) - 1;
      this.currentPage = this.orders_fetch_page;
      this.ordersStartPage = this.currentPage;
    }
    if (page_status == "1") {
      this.currentPage = parseInt(this.orders_fetch_page) + 1;
      this.orders_fetch_page = this.currentPage;
      this.ordersStartPage = this.orders_fetch_page;
    }
    if (page_status == "first") {
      this.orders_fetch_page = this.document_array[0].currentPage;
      this.ordersStartPage = this.document_array[0].currentPage;
    }
    if (page_status == "last") {
      this.orders_fetch_page = this.document_array[0].lastPage;
      this.ordersStartPage = this.document_array[0].lastPage;
    }
    this.ordersReports(
      this.ordersForm.value.from_loc || this.fromLocation,
      this.ordersForm.value.to_loc || this.toLocation,
      this.ordersForm.value.from_date || this.fromDate,
      this.ordersForm.value.to_date || this.toDate,
      this.ordersForm.value.veh_cat || this.truckCategory,
      this.ordersForm.value.trip_id || this.tripId,
      this.ordersForm.value.weight || this.truckWeight,
      this.ordersForm.value.pay_status || this.orderStatus,
      this.ordersForm.value.truckowner_name || this.truckOwner,
      this.download,
      this.perPage,
      this.ordersStartPage
    );
  }

  corporatepagination(page_status: any) {
    if (page_status == "-1") {
      this.corporate_customer = parseInt(this.corporate_customer) - 1;
      this.currentPage = this.corporate_customer;
      this.corporateStartPage = this.currentPage;
    }
    if (page_status == "1") {
      this.currentPage = parseInt(this.corporate_customer) + 1;
      this.corporate_customer = this.currentPage;
      this.corporateStartPage = this.corporate_customer;
    }
    if (page_status == "first") {
      this.corporate_customer = this.document_array[0].currentPage;
      this.corporateStartPage = this.document_array[0].currentPage;
    }
    if (page_status == "last") {
      this.corporate_customer = this.document_array[0].lastPage;
      this.corporateStartPage = this.document_array[0].lastPage;
    }
    this.getReportsCustomer(
      this.searchQuery,
      this.perPage,
      this.corporateStartPage
    );
  }

  corporateCustomerpagination(page_status: any) {
    const fromDateValue = this.customerForm.value.from_date;
    const toDateValue = this.customerForm.value.to_date;

    // Initialize formatted dates to -1
    let formattedFromDate = "-1";
    let formattedToDate = "-1";

    // Check if fromDateValue is valid and not empty
    if (fromDateValue) {
      const parsedFromDate = new Date(fromDateValue);
      if (!isNaN(parsedFromDate.getTime())) {
        formattedFromDate = formatDate(parsedFromDate, "yyyy-MM-dd", "en");
      }
    }

    // Check if toDateValue is valid and not empty
    if (toDateValue) {
      const parsedToDate = new Date(toDateValue);
      if (!isNaN(parsedToDate.getTime())) {
        formattedToDate = formatDate(parsedToDate, "yyyy-MM-dd", "en");
      }
    }

    if (page_status == "-1" && this.corporate_fetch_page > 1) {
      this.corporate_fetch_page = parseInt(this.corporate_fetch_page) - 1;
    } else if (
      page_status == "1" &&
      this.corporate_fetch_page < this.last_page
    ) {
      this.corporate_fetch_page = parseInt(this.corporate_fetch_page) + 1;
    } else if (page_status == "first") {
      this.corporate_fetch_page = 1;
    } else if (page_status == "last") {
      this.corporate_fetch_page = this.last_page;
    }
    this.customerStartPage = this.corporate_fetch_page;
    this.customer(
      formattedFromDate,
      formattedToDate,
      this.customerForm.value.from_loc || this.fromLocation,
      this.customerForm.value.to_loc || this.toLocation,
      this.customerForm.value.sales_order || this.salesOrderNo,
      this.customerForm.value.wo_no || this.workOrderNo,
      this.customerForm.value.trip_id || this.tripId,
      this.customerForm.value.lr_no || this.lrNo,
      this.customerForm.value.vehicle_no || this.vchlNo,
      this.download,
      this.perPage,
      this.customerStartPage
    );
  }

  // ------ Pre Order Reports -------- //

  preordersReports(
    fromLocation: any,
    toLocation: any,
    fromDate: any,
    toDate: any,
    truckCategory: any,
    woid: any,
    download: any,
    perPage: any,
    page: any,
    from?: any
  ) {
    this.preorderArray = [];
    this.document_array = [];
    this.preorderLoading = true;
    this.services
      .getPreOrdersReports(
        this.token,
        fromLocation,
        toLocation,
        fromDate,
        toDate,
        truckCategory,
        download,
        woid,
        perPage,
        this.preOrderStartPage
      )
      .subscribe(
        (response: any) => {
          this.preorderArray = response.body?.data || []; // Assign directly
          this.preorderLoading = false;

          if (response.body.meta) {
            this.document_array.push(response.body.meta);
            this.last_page = response.body.meta?.lastPage;
          }

          this.preOrderDownloadArray = response.body.url;
          if (from === "Download") {
            window.open(this.preOrderDownloadArray, "_blank");
          }
        },
        (error) => {
          this.preorderLoading = false;
          if (error.error.message === "jwt malformed") {
            this.router.navigateByUrl("admin/login");
            window.localStorage.clear();
          }
          if (error.error.message === "jwt expired") {
            this.router.navigateByUrl("admin/login");
            window.localStorage.clear();
          }
          if (error.error.message === "invalid signature") {
            this.router.navigateByUrl("admin/login");
            window.localStorage.clear();
          }

          if (error.error.message === "No record found") {
            this.isNoDataFound = true;
            this.truckArray = [];
            this.TrucksReports = false;
            this.trucksloading = false;
            this.isApplyButtonDisabled = true;
          } else {
            this.isApplyButtonDisabled = false;
          }
          this.snackBar.open(error.error.message, "Fail", {
            duration: 5000,
          });
        }
      );
  }
  // Advanced Search //
  applypreordersFilter() {
    this.document_array = [];
    this.page = 1;
    this.isSearchDisabled = true;
    // Get date values from form
    const fromDateValue = this.pre_orderForm.value.fromDate;
    const toDateValue = this.pre_orderForm.value.toDate;

    // Initialize formatted dates to -1
    let formattedFromDate = "-1";
    let formattedToDate = "-1";

    // Check if fromDateValue is valid and not empty
    if (fromDateValue) {
      const parsedFromDate = new Date(fromDateValue);
      if (!isNaN(parsedFromDate.getTime())) {
        formattedFromDate = formatDate(parsedFromDate, "yyyy-MM-dd", "en");
      }
    }
    // Check if toDateValue is valid and not empty
    if (toDateValue) {
      const parsedToDate = new Date(toDateValue);
      if (!isNaN(parsedToDate.getTime())) {
        formattedToDate = formatDate(parsedToDate, "yyyy-MM-dd", "en");
      }
    }

    if (this.quotesForm.get("toDate")?.enabled && !toDateValue) {
      this.snackBar.open("Please select To Date", "Close", {
        duration: 2000,
      });
      return;
    }
    if (this.pre_orderForm.value.fromDate) {
      this.preordersReports(
        this.pre_orderForm.value.fromLocation || this.fromLocation,
        this.pre_orderForm.value.toLocation || this.toLocation,
        formattedFromDate,
        formattedToDate,
        this.pre_orderForm.value.truckCategory || this.truckCategory,
        this.pre_orderForm.value.woId || this.woid,
        this.download,
        this.perPage,
        this.quoteStartPage
      );
    }
    if (this.pre_orderForm.value.toDate) {
      this.pre_orderForm.value.fromLocation || this.fromLocation,
        this.pre_orderForm.value.toLocation || this.toLocation,
        formattedFromDate;
      formattedToDate;
      this.pre_orderForm.value.truckCategory || this.truckCategory,
        this.pre_orderForm.value.woId || this.woid,
        this.download,
        this.perPage,
        this.quoteStartPage,
        this.report_status;
    }

    if (this.pre_orderForm.value.fromLocation) {
      this.preordersReports(
        this.pre_orderForm.value.fromLocation || this.fromLocation,
        this.pre_orderForm.value.toLocation || this.toLocation,
        formattedFromDate,
        formattedToDate,
        this.pre_orderForm.value.truckCategory || this.truckCategory,
        this.pre_orderForm.value.woId || this.woid,
        this.download,
        this.perPage,
        this.quoteStartPage,
        this.report_status
      );
    }
    if (this.pre_orderForm.value.toLocation) {
      this.preordersReports(
        this.pre_orderForm.value.fromLocation || this.fromLocation,
        this.pre_orderForm.value.toLocation || this.toLocation,
        formattedFromDate,
        formattedToDate,
        this.pre_orderForm.value.truckCategory || this.truckCategory,
        this.pre_orderForm.value.woId || this.woid,
        this.download,
        this.perPage,
        this.quoteStartPage,
        this.report_status
      );
    }

    if (this.pre_orderForm.value.truckCategory) {
      this.preordersReports(
        this.pre_orderForm.value.fromLocation || this.fromLocation,
        this.pre_orderForm.value.toLocation || this.toLocation,
        formattedFromDate,
        formattedToDate,
        this.pre_orderForm.value.truckCategory || this.truckCategory,
        this.pre_orderForm.value.woId || this.woid,
        this.download,
        this.perPage,
        this.quoteStartPage,
        this.report_status
      );
    }
    if (this.pre_orderForm.value.woId) {
      this.preordersReports(
        this.pre_orderForm.value.fromLocation || this.fromLocation,
        this.pre_orderForm.value.toLocation || this.toLocation,
        formattedFromDate,
        formattedToDate,
        this.pre_orderForm.value.truckCategory || this.truckCategory,
        this.pre_orderForm.value.woId || this.woid,
        this.download,
        this.perPage,
        this.quoteStartPage,
        this.report_status
      );
    }
  }

  resetPreOrder() {
    this.document_array = [];
    this.pre_order_fetch_page = 1;
    this.preOrderStartPage = 1;
    this.woid = -1;
    // this.isSearchDisabled = false;
    // this.isSearching = true;
    this.isApplyButtonDisabled = false;
    this.pre_orderForm.reset();
    this.isNoDataFound = false;
    this.preOrderReports = true;
    if (this.newItemPreorder) {
      this.newItemPreorder.nativeElement.value = "";
    }

    this.preordersReports(
      this.fromLocation,
      this.toLocation,
      this.fromDate,
      this.toDate,
      this.truckCategory,
      this.download,
      this.woid,
      this.perPage,
      this.preOrderStartPage
    );
  }

  preOrderSearch(value: string) {
    if (value.length <= 2) {
      this.snackBar.open("Please enter at least 3 characters", "Fail", {
        duration: 3000,
      });
      return;
    }
    if (value != "") {
      this.isApplyButtonDisabled = true;
      this.isSearching = false;
      this.page = 1;
      this.pre_order_fetch_page = 1;
      this.preOrderStartPage = 1;
      let preorderIdKeyword = value || this.tripId;

      this.preordersReports(
        this.pre_orderForm.value.fromDate || this.fromDate,
        this.pre_orderForm.value.toDate || this.toDate,
        this.pre_orderForm.value.fromLocation || this.fromLocation,
        this.pre_orderForm.value.toLocation || this.toLocation,
        this.pre_orderForm.value.truckCategory || this.truckCategory,
        this.pre_orderForm.value.woId || preorderIdKeyword,
        this.download,
        this.perPage,
        this.preOrderStartPage
      );
    }
  }

  preorderspagination(page_status: any) {
    // Handle page status changes
    switch (page_status) {
      case "-1": // Previous page
        this.pre_order_fetch_page = Math.max(
          1,
          parseInt(this.pre_order_fetch_page) - 1
        );
        break;
      case "1": // Next page
        this.pre_order_fetch_page = parseInt(this.pre_order_fetch_page) + 1;
        break;
      case "first": // First page
        this.pre_order_fetch_page = 1;
        break;
      case "last": // Last page
        this.pre_order_fetch_page = this.document_array[0]?.lastPage || 1;
        break;
      default:
        return; // Exit if invalid status
    }

    // Update current page and start page
    this.currentPage = this.pre_order_fetch_page;
    this.preOrderStartPage = this.currentPage;

    // Get and format date values
    const fromDateValue = this.pre_orderForm.value.fromDate;
    const toDateValue = this.pre_orderForm.value.toDate;

    const formattedFromDate = fromDateValue
      ? formatDate(new Date(fromDateValue), "yyyy-MM-dd", "en")
      : "-1";

    const formattedToDate = toDateValue
      ? formatDate(new Date(toDateValue), "yyyy-MM-dd", "en")
      : "-1";

    // Call the API and clear previous data
    this.document_array = []; // Ensure previous data is removed
    this.preordersReports(
      this.pre_orderForm.value.fromLocation || this.fromLocation,
      this.pre_orderForm.value.toLocation || this.toLocation,
      formattedFromDate,
      formattedToDate,
      this.pre_orderForm.value.truckCategory || this.truckCategory,
      this.download,
      this.woid,
      this.perPage,
      this.preOrderStartPage
    );
  }

  preorderdownloadXl(preOrderDownloadArray: string) {
    // Get date values from form
    const fromDateValue = this.pre_orderForm.value.fromDate;
    const toDateValue = this.pre_orderForm.value.toDate;

    // Initialize formatted dates to -1
    let formattedFromDate = "-1";
    let formattedToDate = "-1";

    // Check if fromDateValue is valid and not empty
    if (fromDateValue) {
      const parsedFromDate = new Date(fromDateValue);
      if (!isNaN(parsedFromDate.getTime())) {
        formattedFromDate = formatDate(parsedFromDate, "yyyy-MM-dd", "en");
      }
    }

    // Check if toDateValue is valid and not empty
    if (toDateValue) {
      const parsedToDate = new Date(toDateValue);
      if (!isNaN(parsedToDate.getTime())) {
        formattedToDate = formatDate(parsedToDate, "yyyy-MM-dd", "en");
      }
    }
    if (preOrderDownloadArray === "") {
      this.download = this.downloadPreOrder;
      let from = "Download";
      this.preordersReports(
        this.pre_orderForm.value.fromLocation || this.fromLocation,
        this.pre_orderForm.value.toLocation || this.toLocation,
        formattedFromDate || this.fromDate,
        formattedToDate || this.toDate,
        this.pre_orderForm.value.truckCategory || this.truckCategory,
        this.pre_orderForm.value.woId || this.woid,
        this.download,
        this.perPage,
        this.preOrderStartPage,
        from
      );
    } else {
      window.open(preOrderDownloadArray, "_blank");
    }
  }

  preordersReports1(
    selectedPreOrderId: any,
    fromLocation: any,
    toLocation: any,
    userType: any,
    download: any,
    woid: any,
    perPage: any,
    page: any,
    from?: any
  ) {
    this.preorderArray1 = [];
    this.preorderLoading1 = true;
    this.document_array = [];
    this.last_page = 0;

    this.services
      .getPreOrdersReports1(
        this.token,
        selectedPreOrderId,
        fromLocation,
        toLocation,
        userType,
        download,
        woid,
        perPage,
        this.truckStartPage
      )
      .subscribe(
        (response: any) => {
          this.preorderArray1 = response.body.data;
          this.preorderLoading1 = false;

          this.document_array.push(response.body.meta);
          this.last_page = response.body.meta?.lastPage;
          this.preOrderDownloadArray1 = response.body.url;
          if (from === "Download") {
            window.open(this.preOrderDownloadArray1, "_blank");
          }
        },
        (error) => {
          this.preorderLoading1 = false;
          if (error.error.message === "jwt malformed") {
            this.router.navigateByUrl("admin/login");
            window.localStorage.clear();
          }
          if (error.error.message === "jwt expired") {
            this.router.navigateByUrl("admin/login");
            window.localStorage.clear();
          }
          if (error.error.message === "invalid signature") {
            this.router.navigateByUrl("admin/login");
            window.localStorage.clear();
          }

          if (error.error.message === "No record found") {
            this.isNoDataFound = true;
            this.truckArray = [];
            this.TrucksReports = false;
            this.trucksloading = false;
            this.isApplyButtonDisabled = true;
          } else {
            this.isApplyButtonDisabled = false;
          }
          this.snackBar.open(error.error.message, "Fail", {
            duration: 5000,
          });
        }
      );
  }

  applypreOrder1OrderFilter() {
    this.document_array = [];
    this.page = 1;
    this.isSearchDisabled = true;

    if (this.pre_orderForm1.value.fromLocation) {
      this.preordersReports1(
        this.selectedPreOrderId,
        this.pre_orderForm1.value.fromLocation || this.fromLocation,
        this.pre_orderForm1.value.toLocation || this.toLocation,
        this.pre_orderForm1.value.userType || this.userType,
        this.download,
        this.pre_orderForm1.value.woId || this.woid,
        this.perPage,
        this.quoteStartPage,
        this.report_status
      );
    }
    if (this.pre_orderForm1.value.toLocation) {
      this.preordersReports1(
        this.selectedPreOrderId,
        this.pre_orderForm1.value.fromLocation || this.fromLocation,
        this.pre_orderForm1.value.toLocation || this.toLocation,
        this.pre_orderForm1.value.userType || this.userType,
        this.download,
        this.pre_orderForm1.value.woId || this.woid,
        this.perPage,
        this.quoteStartPage,
        this.report_status
      );
    }

    if (this.pre_orderForm1.value.userType) {
      this.preordersReports1(
        this.selectedPreOrderId,
        this.pre_orderForm1.value.fromLocation || this.fromLocation,
        this.pre_orderForm1.value.toLocation || this.toLocation,
        this.pre_orderForm1.value.userType || this.userType,
        this.download,
        this.pre_orderForm1.value.woId || this.woid,
        this.perPage,
        this.quoteStartPage,
        this.report_status
      );
    }
    if (this.pre_orderForm1.value.woId) {
      this.preordersReports1(
        this.selectedPreOrderId,
        this.pre_orderForm1.value.fromLocation || this.fromLocation,
        this.pre_orderForm1.value.toLocation || this.toLocation,
        this.pre_orderForm1.value.userType || this.userType,
        this.download,
        this.pre_orderForm1.value.woId || this.woid,
        this.perPage,
        this.quoteStartPage,
        this.report_status
      );
    }
  }

  resetPreOrder1() {
    this.document_array = [];
    this.workorder_fetch_page = 1;
    this.workStartPage = 1;
    // this.isSearchDisabled = false;
    // this.isSearching = true;
    this.isApplyButtonDisabled = false;
    this.pre_orderForm1.reset();
    this.isNoDataFound = false;
    this.woid = -1;
    this.preOrderReports = true;
    if (this.newItemPreorder) {
      this.newItemPreorder.nativeElement.value = "";
    }
    this.preordersReports1(
      this.selectedPreOrderId,
      this.fromLocation,
      this.toLocation,
      this.userType,
      this.download,
      this.woid,
      this.perPage,
      this.page
    );
  }

  preOrder1Search(value: string) {
    if (value.length <= 2) {
      this.snackBar.open("Please enter at least 3 characters", "Fail", {
        duration: 3000,
      });
      return;
    }
    if (value != "") {
      this.isApplyButtonDisabled = true;
      this.isSearching = false;
      this.page = 1;
      this.todo_fetch_page = 1;
      this.todoStartPage = 1;
      let preorderIdKeyword1 = value || this.woid;

      this.preordersReports1(
        this.selectedPreOrderId,
        this.pre_orderForm1.value.fromLocation || this.fromLocation,
        this.pre_orderForm1.value.toLocation || this.toLocation,
        this.pre_orderForm1.value.userType || this.userType,
        this.download,
        this.pre_orderForm1.value.woId || preorderIdKeyword1,
        this.perPage,
        this.page
      );
    }
  }

  preorderspagination1(page_status: any) {
    if (page_status == "-1") {
      this.pre_order_fetch_page_1 = parseInt(this.pre_order_fetch_page_1) - 1;
      this.currentPage = this.pre_order_fetch_page_1;
      this.preOrderStartPage1 = this.currentPage;
    }
    if (page_status == "1") {
      this.currentPage = parseInt(this.pre_order_fetch_page_1) + 1;
      this.pre_order_fetch_page_1 = this.currentPage;
      this.preOrderStartPage1 = this.pre_order_fetch_page_1;
    }
    if (page_status == "first") {
      this.pre_order_fetch_page_1 = this.document_array[0].currentPage;
      this.preOrderStartPage1 = this.document_array[0].currentPage;
    }
    if (page_status == "last") {
      this.pre_order_fetch_page_1 = this.document_array[0].lastPage;
      this.preOrderStartPage1 = this.document_array[0].lastPage;
    }
    this.preordersReports1(
      this.selectedPreOrderId,
      this.pre_orderForm1.value.fromLocation || this.fromLocation,
      this.pre_orderForm1.value.toLocation || this.toLocation,
      this.userType,
      this.download,
      this.pre_orderForm1.value.woId || this.woid,
      this.perPage,
      this.preOrderStartPage1
    );
  }

  preorder1downloadXl(preOrderDownloadArray1: string) {
    if (preOrderDownloadArray1 === "") {
      this.download = this.downloadPreOrder;
      let from = "Download";
      this.preordersReports1(
        this.selectedPreOrderId,
        this.fromLocation,
        this.toLocation,
        this.userType,
        this.download,
        this.woid,
        this.perPage,
        this.preOrderStartPage1,
        from
      );
    } else {
      window.open(preOrderDownloadArray1, "_blank");
    }
  }

  GoToWo(item: any) {
    this.document_array = [];
    this.download = -1;
    this.resetWorkOrder();
    this.todo = false;
    this.quotes = false;
    this.trips = false;
    this.payments = false;
    this.trucks = false;
    this.drivers = false;
    this.orders = false;
    this.corporatecustomers = false;
    this.transporter = false;
    this.searchData = false;
    this.reportCloseWorkOrders = false;
    this.workorder_fetch_page = 1;
    this.workStartPage = 1;
    this.workOrdersReports = false;
    this.preOrderReports = true;
    this.workorderloading = true;
    this.advancedWorkOrders = true;
    this.workorders = false;
    this.pre_orders = false;
    this.pre_orders_2 = true;
    this.selectedPreOrderId = item._id;

    this.preordersReports1(
      item._id,
      this.fromLocation,
      this.toLocation,
      this.userType,
      this.download,
      this.woid,
      this.perPage,
      this.page
    );
  }

  // _________________________________ //
  workordersReports(
    fromDate: any,
    toDate: any,
    salesOrderNo: any,
    workorder_no: any,
    download: any,
    customerName: any,
    perPage: any,
    page: any,
    from?: any
  ) {
    this.services
      .getWorkOrdersReports(
        this.token,
        fromDate,
        toDate,
        salesOrderNo,
        workorder_no,
        this.customerName,
        download,
        perPage,
        this.workorder_fetch_page,
        this.workStartPage
      )
      .subscribe(
        (response: any) => {
          this.workorderloading = false;
          this.workOrderssArray = response.body.data;
          this.document_array.push(response.body.meta);
          this.last_page = response.body.meta?.lastPage;
          this.WodownloadArray = response.body.url;
          if (from === "Download") {
            window.open(this.WodownloadArray, "_blank");
          }
        },
        (error) => {
          if (error.error.message === "jwt malformed") {
            this.router.navigateByUrl("admin/login");
            window.localStorage.clear();
          }
          if (error.error.message === "jwt expired") {
            this.router.navigateByUrl("admin/login");
            window.localStorage.clear();
          }
          if (error.error.message === "invalid signature") {
            this.router.navigateByUrl("admin/login");
            window.localStorage.clear();
          }
          if (error.error.message === "No record found") {
            this.isNoDataFound = true;
            this.workOrderssArray = [];
            this.workOrdersReports = false;
            this.workorderloading = false;
            this.isApplyButtonDisabled = true;
          } else {
            this.isApplyButtonDisabled = false;
          }
          this.snackBar.open(error.error.message, "Fail", {
            duration: 5000,
          });
        }
      );
  }

  workorderspagination(page_status: any) {
    if (page_status == "-1") {
      this.workorder_fetch_page = parseInt(this.workorder_fetch_page) - 1;
      this.currentPage = this.workorder_fetch_page;
      this.workStartPage = this.currentPage;
    }
    if (page_status == "1") {
      this.currentPage = parseInt(this.workorder_fetch_page) + 1;
      this.workorder_fetch_page = this.currentPage;
      this.workStartPage = this.workorder_fetch_page;
    }
    if (page_status == "first") {
      this.workorder_fetch_page = this.document_array[0].currentPage;
      this.workStartPage = this.document_array[0].currentPage;
    }
    if (page_status == "last") {
      this.workorder_fetch_page = this.document_array[0].lastPage;
      this.workStartPage = this.document_array[0].lastPage;
    }
    this.workordersReports(
      this.workOrderForm.value.salese_Order_Number || this.salesOrderNo,
      this.fromDate,
      this.toDate,
      this.workOrderForm.value.work_Order_Number || this.workorder_no,
      this.download,
      this.customerName,
      this.perPage,
      this.workStartPage
    );
  }

  getReportsCustomer(searchQuery: any, perPage: any, page: any) {
    this.services
      .reportsCustomer(
        this.token,
        searchQuery,
        perPage,
        this.corporateStartPage
      )
      .subscribe(
        (response: any) => {
          this.corporateloading = false;
          this.customersArray = response.body.totalListWithPagination.data;
          this.document_array.push(response.body.totalListWithPagination.meta);
          this.last_page = response.body.totalListWithPagination.meta?.lastPage;
          if (response.body.totalListWithPagination.data.length === 0) {
            this.isNoDataFound = true;
            this.isNoRecordsFound = true;
            this.customersArray = [];
            this.customerReport = false;
          }
        },
        (error) => {
          if (error.error.message === "jwt malformed") {
            this.router.navigateByUrl("admin/login");
            window.localStorage.clear();
          }
          if (error.error.message === "jwt expired") {
            this.router.navigateByUrl("admin/login");
            window.localStorage.clear();
          }
          if (error.error.message === "invalid signature") {
            this.router.navigateByUrl("admin/login");
            window.localStorage.clear();
          }
          if (error.error.message === "No record found") {
            this.isNoDataFound = true;
            this.isNoRecordsFound = true;
            this.customersArray = [];
            this.customerReport = false;
          }
          this.snackBar.open(error.error.message, "Fail", {
            duration: 5000,
          });
        }
      );
  }

  applyCustomerFilter() {
    const fromDateValue = this.customerForm.value.from_date;
    const toDateValue = this.customerForm.value.to_date;

    // Initialize formatted dates to -1
    let formattedFromDate = "-1";
    let formattedToDate = "-1";

    // Check if fromDateValue is valid and not empty
    if (fromDateValue) {
      const parsedFromDate = new Date(fromDateValue);
      if (!isNaN(parsedFromDate.getTime())) {
        formattedFromDate = formatDate(parsedFromDate, "yyyy-MM-dd", "en");
      }
    }

    // Check if toDateValue is valid and not empty
    if (toDateValue) {
      const parsedToDate = new Date(toDateValue);
      if (!isNaN(parsedToDate.getTime())) {
        formattedToDate = formatDate(parsedToDate, "yyyy-MM-dd", "en");
      }
    }

    if (this.customerForm.get("to_date")?.enabled && !toDateValue) {
      this.snackBar.open("Please select To Date", "Close", {
        duration: 2000,
      });
      return;
    }
    this.customerStartPage = 1;
    // this.download = this.downloadReports;
    if (this.customerForm.value.from_date) {
      this.customer(
        formattedFromDate,
        formattedToDate,
        this.customerForm.value.from_loc || this.fromLocation,
        this.customerForm.value.to_loc || this.toLocation,
        this.customerForm.value.sales_order || this.salesOrderNo,
        this.customerForm.value.wo_no || this.workOrderNo,
        this.customerForm.value.trip_id || this.tripId,
        this.customerForm.value.lr_no || this.lrNo,
        this.customerForm.value.vehicle_no || this.vchlNo,
        this.download,
        this.perPage,
        this.customerStartPage
      );
    }
    if (this.customerForm.value.to_date) {
      this.customer(
        formattedFromDate,
        formattedToDate,
        this.customerForm.value.from_loc || this.fromLocation,
        this.customerForm.value.to_loc || this.toLocation,
        this.customerForm.value.sales_order || this.salesOrderNo,
        this.customerForm.value.wo_no || this.workOrderNo,
        this.customerForm.value.trip_id || this.tripId,
        this.customerForm.value.lr_no || this.lrNo,
        this.customerForm.value.vehicle_no || this.vchlNo,
        this.download,
        this.perPage,
        this.customerStartPage
      );
    }
    if (this.customerForm.value.from_loc) {
      this.customer(
        formattedFromDate,
        formattedToDate,
        this.customerForm.value.from_loc || this.fromLocation,
        this.customerForm.value.to_loc || this.toLocation,
        this.customerForm.value.sales_order || this.salesOrderNo,
        this.customerForm.value.wo_no || this.workOrderNo,
        this.customerForm.value.trip_id || this.tripId,
        this.customerForm.value.lr_no || this.lrNo,
        this.customerForm.value.vehicle_no || this.vchlNo,
        this.download,
        this.perPage,
        this.customerStartPage
      );
    }
    if (this.customerForm.value.to_loc) {
      this.customer(
        formattedFromDate,
        formattedToDate,
        this.customerForm.value.from_loc || this.fromLocation,
        this.customerForm.value.to_loc || this.toLocation,
        this.customerForm.value.sales_order || this.salesOrderNo,
        this.customerForm.value.wo_no || this.workOrderNo,
        this.customerForm.value.trip_id || this.tripId,
        this.customerForm.value.lr_no || this.lrNo,
        this.customerForm.value.vehicle_no || this.vchlNo,
        this.download,
        this.perPage,
        this.customerStartPage
      );
    }
    if (this.customerForm.value.trip_id) {
      this.customer(
        formattedFromDate,
        formattedToDate,
        this.customerForm.value.from_loc || this.fromLocation,
        this.customerForm.value.to_loc || this.toLocation,
        this.customerForm.value.sales_order || this.salesOrderNo,
        this.customerForm.value.wo_no || this.workOrderNo,
        this.customerForm.value.trip_id || this.tripId,
        this.customerForm.value.lr_no || this.lrNo,
        this.customerForm.value.vehicle_no || this.vchlNo,
        this.download,
        this.perPage,
        this.customerStartPage
      );
    }
    if (this.customerForm.value.vehicle_no) {
      this.customer(
        formattedFromDate,
        formattedToDate,
        this.customerForm.value.from_loc || this.fromLocation,
        this.customerForm.value.to_loc || this.toLocation,
        this.customerForm.value.sales_order || this.salesOrderNo,
        this.customerForm.value.wo_no || this.workOrderNo,
        this.customerForm.value.trip_id || this.tripId,
        this.customerForm.value.lr_no || this.lrNo,
        this.customerForm.value.vehicle_no || this.vchlNo,
        this.download,
        this.perPage,
        this.customerStartPage
      );
    }
    if (this.customerForm.value.lr_no) {
      this.customer(
        formattedFromDate,
        formattedToDate,
        this.customerForm.value.from_loc || this.fromLocation,
        this.customerForm.value.to_loc || this.toLocation,
        this.customerForm.value.sales_order || this.salesOrderNo,
        this.customerForm.value.wo_no || this.workOrderNo,
        this.customerForm.value.trip_id || this.tripId,
        this.customerForm.value.lr_no || this.lrNo,
        this.customerForm.value.vehicle_no || this.vchlNo,
        this.download,
        this.perPage,
        this.customerStartPage
      );
    }
    if (this.customerForm.value.wo_no) {
      this.customer(
        formattedFromDate,
        formattedToDate,
        this.customerForm.value.from_loc || this.fromLocation,
        this.customerForm.value.to_loc || this.toLocation,
        this.customerForm.value.sales_order || this.salesOrderNo,
        this.customerForm.value.wo_no || this.workOrderNo,
        this.customerForm.value.trip_id || this.tripId,
        this.customerForm.value.lr_no || this.lrNo,
        this.customerForm.value.vehicle_no || this.vchlNo,
        this.download,
        this.perPage,
        this.customerStartPage
      );
    }
    if (this.customerForm.value.sales_order) {
      this.customer(
        formattedFromDate,
        formattedToDate,
        this.customerForm.value.from_loc || this.fromLocation,
        this.customerForm.value.to_loc || this.toLocation,
        this.customerForm.value.sales_order || this.salesOrderNo,
        this.customerForm.value.wo_no || this.workOrderNo,
        this.customerForm.value.trip_id || this.tripId,
        this.customerForm.value.lr_no || this.lrNo,
        this.customerForm.value.vehicle_no || this.vchlNo,
        this.download,
        this.perPage,
        this.customerStartPage
      );
    }
  }

  customer(
    fromDate: any,
    toDate: any,
    fromLocation: any,
    toLocation: any,
    salesOrderNo: any,
    wo_no: any,
    tripId: any,
    lrNo: any,
    vchlNo: any,
    download: any,
    perPage: any,
    page: any,
    from?: any
  ) {
    this.services
      .getCorporateCustomerReports(
        this.token,
        this.customerDetails_id,
        fromDate,
        toDate,

        fromLocation,
        toLocation,
        salesOrderNo,
        wo_no,
        tripId,
        lrNo,
        vchlNo,
        download,
        perPage,
        this.customerStartPage
      )
      .subscribe(
        (response: any) => {
          if (response.status == 200) {
            this.document_array = [];
            this.customerReport = false;
            this.customerDetailsEnable = true;
            this.corporatecustomersArray = response.body.data;
            this.document_array.push(response.body.meta);
            this.last_page = response.body.meta?.lastPage;
            this.corporatedownloadArray = response.body.url;
            if (from === "Download") {
              window.open(this.corporatedownloadArray, "_blank");
            }
          }
        },
        (error) => {
          if (error.error.message === "jwt malformed") {
            this.router.navigateByUrl("admin/login");
            window.localStorage.clear();
          }
          if (error.error.message === "jwt expired") {
            this.router.navigateByUrl("admin/login");
            window.localStorage.clear();
          }
          if (error.error.message === "invalid signature") {
            this.router.navigateByUrl("admin/login");
            window.localStorage.clear();
          }
          if (error.error.message === "No record found") {
            this.corporatecustomersArray = [];
            this.customerReport = false;
            this.customerDetailsEnable = false;
            this.corporateloading = false;
            this.isNoDataFound = true;
            this.isNoRecordsFound = true;
            this.isApplyButtonDisabled = true;
          } else {
            this.isApplyButtonDisabled = false;
          }

          if (error.error.message === "Internal server error.!") {
            this.resetCustomer();
          }

          this.snackBar.open(error.error.message, "Fail", {
            duration: 5000,
          });
        }
      );
  }

  customerDetails(item: any) {
    if (this.corporateTab) {
      this.corporateTab.nativeElement.value = "";
    }
    if (item.tripInfo?.length === 0) {
      this.snackBar.open("No Records Found", "Fail", {
        duration: 5000,
      });
      return;
    }
    if (item != "") {
      this.corporateCustomer = false;
      this.corporateCustomeReport = true;
      this.CID = false;
      this.Trip_Id = true;
      this.customerDetails_id = item._id;
      this.advancedCustomers = true;
      this.isSearching = true;
      this.page = 1;
      this.customerStartPage = 1;
      this.corporate_fetch_page = 1;
      this.customer(
        this.fromDate,
        this.toDate,
        this.fromLocation,
        this.toLocation,
        this.salesOrderNo,
        this.workOrderNo,
        this.tripId,
        this.lrNo,
        this.vchlNo,
        this.download,
        this.perPage,
        this.page
      );
    }
  }

  applyTodoFilter() {
    this.document_array = [];
    this.page = 1;
    this.isSearchDisabled = true;
    this.todoStartPage = 1;
    this.todo_fetch_page = 1;

    // Get date values from form
    const fromDateValue = this.todoForm.value.from_date;
    const toDateValue = this.todoForm.value.to_date;

    // Initialize formatted dates to -1
    let formattedFromDate = "-1";
    let formattedToDate = "-1";

    // Check if fromDateValue is valid and not empty
    if (fromDateValue) {
      const parsedFromDate = new Date(fromDateValue);
      if (!isNaN(parsedFromDate.getTime())) {
        formattedFromDate = formatDate(parsedFromDate, "yyyy-MM-dd", "en");
      }
    }

    // Check if toDateValue is valid and not empty
    if (toDateValue) {
      const parsedToDate = new Date(toDateValue);
      if (!isNaN(parsedToDate.getTime())) {
        formattedToDate = formatDate(parsedToDate, "yyyy-MM-dd", "en");
      }
    }

    if (this.todoForm.get("to_date")?.enabled && !toDateValue) {
      this.snackBar.open("Please select To Date", "Close", {
        duration: 2000,
      });
      return;
    }

    if (this.todoForm.value.from_date) {
      this.todoReports(
        formattedFromDate,
        formattedToDate,
        this.todoForm.value.trip_status || this.tripStatus,
        this.todoForm.value.trip_id || this.tripId,
        this.todoForm.value.bank_name
          ? this.todoForm.value.bank_name
          : this.bankName,
        this.todoForm.value.truck_no || this.truckNo,
        this.download,
        this.perPage,
        this.todoStartPage
      );
    }
    if (this.todoForm.value.to_date) {
      this.todoForm.value.trip_id || this.tripId,
        this.todoForm.value.trip_status || this.tripStatus,
        this.todoForm.value.bank_name
          ? this.todoForm.value.bank_name
          : this.bankName,
        this.todoForm.value.truck_no || this.truckNo,
        this.download,
        this.perPage,
        this.todoStartPage;
    }
    if (this.todoForm.value.trip_id) {
      this.todoReports(
        formattedFromDate,
        formattedToDate,
        this.todoForm.value.trip_status || this.tripStatus,
        this.todoForm.value.trip_id || this.tripId,
        this.todoForm.value.bank_name
          ? this.todoForm.value.bank_name
          : this.bankName,
        this.todoForm.value.truck_no || this.truckNo,
        this.download,
        this.perPage,
        this.todoStartPage
      );
    }
    if (this.todoForm.value.trip_status) {
      this.todoReports(
        formattedFromDate,
        formattedToDate,
        this.todoForm.value.trip_status || this.tripStatus,
        this.todoForm.value.trip_id || this.tripId,
        this.todoForm.value.bank_name
          ? this.todoForm.value.bank_name
          : this.bankName,
        this.todoForm.value.truck_no || this.truckNo,
        this.download,
        this.perPage,
        this.todoStartPage
      );
    }
    if (this.todoForm.value.bank_name) {
      this.todoReports(
        formattedFromDate,
        formattedToDate,
        this.todoForm.value.trip_status || this.tripStatus,
        this.todoForm.value.trip_id || this.tripId,
        this.todoForm.value.bank_name
          ? this.todoForm.value.bank_name
          : this.bankName,
        this.todoForm.value.truck_no || this.truckNo,
        this.download,
        this.perPage,
        this.todoStartPage
      );
    }
    if (this.todoForm.value.truck_no) {
      this.todoReports(
        formattedFromDate,
        formattedToDate,
        this.todoForm.value.trip_status || this.tripStatus,
        this.todoForm.value.trip_id || this.tripId,
        this.todoForm.value.bank_name
          ? this.todoForm.value.bank_name
          : this.bankName,
        this.todoForm.value.truck_no || this.truckNo,
        this.download,
        this.perPage,
        this.todoStartPage
      );
    }
  }

  applyQuoteFilter() {
    this.document_array = [];
    this.page = 1;
    this.isSearchDisabled = true;
    // Get date values from form
    const fromDateValue = this.quotesForm.value.from_date;
    const toDateValue = this.quotesForm.value.to_date;

    // Initialize formatted dates to -1
    let formattedFromDate = "-1";
    let formattedToDate = "-1";

    // Check if fromDateValue is valid and not empty
    if (fromDateValue) {
      const parsedFromDate = new Date(fromDateValue);
      if (!isNaN(parsedFromDate.getTime())) {
        formattedFromDate = formatDate(parsedFromDate, "yyyy-MM-dd", "en");
      }
    }

    // Check if toDateValue is valid and not empty
    if (toDateValue) {
      const parsedToDate = new Date(toDateValue);
      if (!isNaN(parsedToDate.getTime())) {
        formattedToDate = formatDate(parsedToDate, "yyyy-MM-dd", "en");
      }
    }

    if (this.quotesForm.get("to_date")?.enabled && !toDateValue) {
      this.snackBar.open("Please select To Date", "Close", {
        duration: 2000,
      });
      return;
    }

    if (this.quotesForm.value.from_date) {
      this.quotesReports(
        formattedFromDate,
        formattedToDate,
        this.quotesForm.value.from_loc || this.fromLocation,
        this.quotesForm.value.to_loc || this.toLocation,
        this.quotesForm.value.truck_categ || this.truckCategory,
        this.quotesForm.value.quote_id || this.quotesId,
        this.download,
        this.perPage,
        this.quoteStartPage,
        this.report_status
      );
    }
    if (this.quotesForm.value.to_date) {
      formattedFromDate;
      formattedToDate;
      this.quotesForm.value.from_loc || this.fromLocation,
        this.quotesForm.value.to_loc || this.toLocation,
        this.quotesForm.value.truck_categ || this.truckCategory,
        this.quotesForm.value.quote_id || this.quotesId,
        this.download,
        this.perPage,
        this.quoteStartPage,
        this.report_status;
    }
    if (this.quotesForm.value.from_loc) {
      this.quotesReports(
        formattedFromDate,
        formattedToDate,
        this.quotesForm.value.from_loc || this.fromLocation,
        this.quotesForm.value.to_loc || this.toLocation,
        this.quotesForm.value.truck_categ || this.truckCategory,
        this.quotesForm.value.quote_id || this.quotesId,
        this.download,
        this.perPage,
        this.quoteStartPage,
        this.report_status
      );
    }
    if (this.quotesForm.value.to_loc) {
      this.quotesReports(
        formattedFromDate,
        formattedToDate,
        this.quotesForm.value.from_loc || this.fromLocation,
        this.quotesForm.value.to_loc || this.toLocation,
        this.quotesForm.value.truck_categ || this.truckCategory,
        this.quotesForm.value.quote_id || this.quotesId,
        this.download,
        this.perPage,
        this.quoteStartPage,
        this.report_status
      );
    }
    if (this.quotesForm.value.quote_id) {
      this.quotesReports(
        formattedFromDate,
        formattedToDate,
        this.quotesForm.value.from_loc || this.fromLocation,
        this.quotesForm.value.to_loc || this.toLocation,
        this.quotesForm.value.truck_categ || this.truckCategory,
        this.quotesForm.value.quote_id || this.quotesId,
        this.download,
        this.perPage,
        this.quoteStartPage,
        this.report_status
      );
    }
    if (this.quotesForm.value.truck_categ) {
      this.quotesReports(
        formattedFromDate,
        formattedToDate,
        this.quotesForm.value.from_loc || this.fromLocation,
        this.quotesForm.value.to_loc || this.toLocation,
        this.quotesForm.value.truck_categ || this.truckCategory,
        this.quotesForm.value.quote_id || this.quotesId,
        this.download,
        this.perPage,
        this.quoteStartPage,
        this.report_status
      );
    }
  }

  applyPaymentsFilter() {
    // this.download = this.downloadReports;
    this.document_array = [];
    this.page = 1;
    this.isSearchDisabled = true;
    this.paymentStartPage = 1;

    // Get date values from form
    const fromDateValue = this.paymentsForm.value.from_date;
    const toDateValue = this.paymentsForm.value.to_date;

    // Initialize formatted dates to -1
    let formattedFromDate = "-1";
    let formattedToDate = "-1";

    // Check if fromDateValue is valid and not empty
    if (fromDateValue) {
      const parsedFromDate = new Date(fromDateValue);
      if (!isNaN(parsedFromDate.getTime())) {
        formattedFromDate = formatDate(parsedFromDate, "yyyy-MM-dd", "en");
      }
    }

    // Check if toDateValue is valid and not empty
    if (toDateValue) {
      const parsedToDate = new Date(toDateValue);
      if (!isNaN(parsedToDate.getTime())) {
        formattedToDate = formatDate(parsedToDate, "yyyy-MM-dd", "en");
      }
    }

    if (this.paymentsForm.get("to_date")?.enabled && !toDateValue) {
      this.snackBar.open("Please select To Date", "Close", {
        duration: 2000,
      });
      return;
    }

    if (this.paymentsForm.value.from_date) {
      this.paymentsReports(
        this.paymentsForm.value.from_loc || this.fromLocation,
        this.paymentsForm.value.to_loc || this.toLocation,
        formattedFromDate,
        formattedToDate,
        this.paymentsForm.value.payment_status || this.paymentStatus,
        this.paymentsForm.value.trip_id || this.tripId,
        this.download,
        this.perPage,
        this.page
      );
    }
    if (this.paymentsForm.value.to_date) {
      this.paymentsReports(
        this.paymentsForm.value.from_loc || this.fromLocation,
        this.paymentsForm.value.to_loc || this.toLocation,
        formattedFromDate,
        formattedToDate,
        this.paymentsForm.value.payment_status || this.paymentStatus,
        this.paymentsForm.value.trip_id || this.tripId,
        this.download,
        this.perPage,
        this.page
      );
    }
    if (this.paymentsForm.value.from_loc) {
      this.paymentsReports(
        this.paymentsForm.value.from_loc || this.fromLocation,
        this.paymentsForm.value.to_loc || this.toLocation,
        formattedFromDate,
        formattedToDate,
        this.paymentsForm.value.payment_status || this.paymentStatus,
        this.paymentsForm.value.trip_id || this.tripId,
        this.download,
        this.perPage,
        this.page
      );
    }
    if (this.paymentsForm.value.to_loc) {
      this.paymentsReports(
        this.paymentsForm.value.from_loc || this.fromLocation,
        this.paymentsForm.value.to_loc || this.toLocation,
        formattedFromDate,
        formattedToDate,
        this.paymentsForm.value.payment_status || this.paymentStatus,
        this.paymentsForm.value.trip_id || this.tripId,
        this.download,
        this.perPage,
        this.page
      );
    }
    if (this.paymentsForm.value.trip_id) {
      this.paymentsReports(
        this.paymentsForm.value.from_loc || this.fromLocation,
        this.paymentsForm.value.to_loc || this.toLocation,
        formattedFromDate,
        formattedToDate,
        this.paymentsForm.value.payment_status || this.paymentStatus,
        this.paymentsForm.value.trip_id || this.tripId,
        this.download,
        this.perPage,
        this.page
      );
    }
    if (this.paymentsForm.value.payment_status) {
      this.paymentsReports(
        this.paymentsForm.value.from_loc || this.fromLocation,
        this.paymentsForm.value.to_loc || this.toLocation,
        formattedFromDate,
        formattedToDate,
        this.paymentsForm.value.payment_status || this.paymentStatus,
        this.paymentsForm.value.trip_id || this.tripId,
        this.download,
        this.perPage,
        this.page
      );
    }
  }

  resetWorkOrder() {
    this.document_array = [];
    this.workorder_fetch_page = 1;
    this.workStartPage = 1;
    // this.isSearchDisabled = false;
    // this.isSearching = true;
    this.isApplyButtonDisabled = false;
    this.workOrderForm.reset();
    this.isNoDataFound = false;
    this.workOrdersReports = true;
    if (this.newItemWO) {
      this.newItemWO.nativeElement.value = "";
    }
    this.workordersReports(
      this.fromDate,
      this.toDate,
      this.salesOrderNo,
      this.workorder_no,
      this.download,
      this.customerName,
      this.perPage,
      this.workStartPage
    );
  }
  resetTodo() {
    this.document_array = [];
    this.todoForm.reset();
    this.todoStartPage = 1;
    this.todo_fetch_page = 1;
    this.todoReport = true;
    this.reportCloseTodo = true;
    this.isApplyButtonDisabled = false;
    this.isNoDataFound = false;
    if (this.newid) {
      this.newid.nativeElement.value = "";
    }

    this.todoReports(
      this.fromDate,
      this.toDate,
      this.tripStatus,
      this.tripId,
      this.bankName,
      this.truckNo,
      this.download,
      this.perPage,
      this.page
    );
  }
  resetQuotes() {
    this.document_array = [];
    this.quotesForm.reset();
    this.quoteStartPage = 1;
    this.fetch_page = 1;
    this.quotesReport = true;
    this.reportCloseQuote = true;
    this.isApplyButtonDisabled = false;
    this.isNoDataFound = false;

    if (this.newItem) {
      this.newItem.nativeElement.value = "";
    }
    this.quotesReports(
      this.fromLocation,
      this.toLocation,
      this.fromDate,
      this.toDate,
      this.truckCategory,
      this.tripId,
      this.download,
      this.perPage,
      this.quoteStartPage,
      this.report_status
    );
  }

  paymentReset() {
    this.document_array = [];
    this.paymentsForm.reset();
    this.payment_fetch_page = 1;
    this.paymentStartPage = 1;
    this.isApplyButtonDisabled = false;
    this.isNoDataFound = false;
    this.paymentsReport = true;
    this.reportClosePayments = true;
    if (this.paymentTab) {
      this.paymentTab.nativeElement.value = "";
    }
    this.paymentsReports(
      this.fromLocation,
      this.toLocation,
      this.fromDate,
      this.toDate,
      this.paymentStatus,
      this.tripId,
      this.download,
      this.perPage,
      this.page
    );
  }

  resetCustomer() {
    this.document_array = [];
    this.customerForm.reset();
    this.customerStartPage = 1;
    this.corporate_fetch_page = 1;
    this.isApplyButtonDisabled = false;
    this.isNoDataFound = false;
    this.isNoRecordsFound = false;
    this.customerReport = true;
    this.reportCloseCustomers = true;
    if (this.corporateTab) {
      this.corporateTab.nativeElement.value = "";
    }
    this.customer(
      this.fromDate,
      this.toDate,
      this.fromLocation,
      this.toLocation,
      this.salesOrderNo,
      this.workOrderNo,
      this.tripId,
      this.lrNo,
      this.vchlNo,
      this.download,
      this.perPage,
      this.customerStartPage
    );
  }

  driverReset() {
    this.document_array = [];
    this.driversForm.reset();
    this.driverStartPage = 1;
    this.drivers_fetch_page = 1;
    this.DriversReports = true;
    this.reportCloseDrivers = true;
    this.isApplyButtonDisabled = false;
    this.isNoDataFound = false;
    if (this.driverTab) {
      this.driverTab.nativeElement.value = "";
    }
    this.driversReports(
      this.truckNo,
      this.truckOwnerName,
      this.driverStatus,
      this.download,
      this.driverName,
      this.driver_status,
      this.perPage,
      this.page
    );
  }

  resetTrips() {
    this.document_array = [];
    this.tripsForm.reset();
    this.tripsStartPage = 1;
    this.trips_fetch_page = 1;
    this.tripsReport = true;
    this.reportCloseTrips = true;
    this.isApplyButtonDisabled = false;
    if (this.tripsTab) {
      this.tripsTab.nativeElement.value = "";
    }
    this.tripsReports(
      this.fromLocation,
      this.toLocation,
      this.fromDate,
      this.toDate,
      this.truckCategory,
      this.truckWeight,
      this.vehicleNumber,
      this.tripId,
      this.tripStatus,
      this.download,
      this.perPage,
      this.page
    );
  }

  transporterReset() {
    this.document_array = [];
    this.transportForm.reset();
    this.transportStartPage = 1;
    this.transport_fetch_page = 1;
    this.transporterReport = true;
    this.reportCloseTransporters = true;
    this.isApplyButtonDisabled = false;
    this.isNoDataFound = false;

    this.truckOwnerName = -1;
    if (this.transporterTab) {
      this.transporterTab.nativeElement.value = "";
    }
    this.transporterReports(
      this.salesOrderNo,
      this.workOrderNo,
      this.truckOwnerName,
      this.truckNo,
      this.fromDate,
      this.toDate,
      this.tripId,
      this.download,
      this.perPage,
      this.transportStartPage
    );
  }

  resetTrucks() {
    this.document_array = [];
    this.trucksForm.reset();
    this.truckStartPage = 1;
    this.truck_fetch_page = 1;
    this.TrucksReports = true;
    this.reportCloseTrucks = true;
    this.isApplyButtonDisabled = false;
    this.isNoDataFound = false;
    if (this.trucksTab) {
      this.trucksTab.nativeElement.value = "";
    }
    this.trucksReports(
      this.fromLocation,
      this.toLocation,
      this.fromDate,
      this.toDate,
      this.truckCategory,
      this.truckWeight,
      this.vehicleNumber,
      this.tripId,
      this.tripStatus,
      this.download,
      this.truckNumber,
      this.perPage,
      this.report_status,
      this.truckStartPage
    );
  }

  resetOrders() {
    this.document_array = [];
    this.ordersForm.reset();
    this.ordersStartPage = 1;
    this.orders_fetch_page = 1;
    this.OrdersReports = true;
    this.reportCloseOrders = true;
    this.isApplyButtonDisabled = false;
    this.isNoDataFound = false;
    if (this.orderTab) {
      this.orderTab.nativeElement.value = "";
    }
    this.ordersReports(
      this.fromLocation,
      this.toLocation,
      this.fromDate,
      this.toDate,
      this.truckCategory,
      this.tripId,
      this.truckWeight,
      this.orderStatus,
      this.truckOwner,
      this.download,
      this.perPage,
      this.page
    );
  }

  applyTripsFilter() {
    this.isSearchDisabled = true;
    this.page = 1;
    this.tripsStartPage = 1;
    this.trips_fetch_page = 1;
    // this.download = this.downloadReports;
    this.document_array = [];

    // Get date values from form
    const fromDateValue = this.tripsForm.value.from_date;
    const toDateValue = this.tripsForm.value.to_date;

    // Initialize formatted dates to -1
    let formattedFromDate = "-1";
    let formattedToDate = "-1";

    // Check if fromDateValue is valid and not empty
    if (fromDateValue) {
      const parsedFromDate = new Date(fromDateValue);
      if (!isNaN(parsedFromDate.getTime())) {
        formattedFromDate = formatDate(parsedFromDate, "yyyy-MM-dd", "en");
      }
    }

    // Show a snackbar if to_date is enabled but not selected
    if (this.tripsForm.get("to_date")?.enabled && !toDateValue) {
      this.snackBar.open("Please select To Date", "Close", {
        duration: 2000,
      });
      return;
    }

    // Check if toDateValue is valid and not empty
    if (toDateValue) {
      const parsedToDate = new Date(toDateValue);
      if (!isNaN(parsedToDate.getTime())) {
        formattedToDate = formatDate(parsedToDate, "yyyy-MM-dd", "en");
      }
    }

    if (this.tripsForm.value.from_date) {
      this.tripsReports(
        this.tripsForm.value.from_loc || this.fromLocation,
        this.tripsForm.value.to_loc || this.toLocation,
        formattedFromDate,
        formattedToDate,
        this.tripsForm.value.veh_cat || this.truckCategory,
        this.tripsForm.value.weight || this.truckWeight,
        this.tripsForm.value.vehcl_no || this.vehicleNumber,
        this.tripsForm.value.trip_id || this.tripId,
        this.tripsForm.value.trip_status || this.tripStatus,
        this.download,
        this.perPage,
        this.page
      );
    }
    if (this.tripsForm.value.to_date) {
      this.tripsReports(
        this.tripsForm.value.from_loc || this.fromLocation,
        this.tripsForm.value.to_loc || this.toLocation,
        formattedFromDate,
        formattedToDate,
        this.tripsForm.value.veh_cat || this.truckCategory,
        this.tripsForm.value.weight || this.truckWeight,
        this.tripsForm.value.vehcl_no || this.vehicleNumber,
        this.tripsForm.value.trip_id || this.tripId,
        this.tripsForm.value.trip_status || this.tripStatus,
        this.download,
        this.perPage,
        this.page
      );
    }
    if (this.tripsForm.value.from_loc) {
      this.tripsReports(
        this.tripsForm.value.from_loc || this.fromLocation,
        this.tripsForm.value.to_loc || this.toLocation,
        formattedFromDate,
        formattedToDate,
        this.tripsForm.value.veh_cat || this.truckCategory,
        this.tripsForm.value.weight || this.truckWeight,
        this.tripsForm.value.vehcl_no || this.vehicleNumber,
        this.tripsForm.value.trip_id || this.tripId,
        this.tripsForm.value.trip_status || this.tripStatus,
        this.download,
        this.perPage,
        this.page
      );
    }
    if (this.tripsForm.value.to_loc) {
      this.tripsReports(
        this.tripsForm.value.from_loc || this.fromLocation,
        this.tripsForm.value.to_loc || this.toLocation,
        formattedFromDate,
        formattedToDate,
        this.tripsForm.value.veh_cat || this.truckCategory,
        this.tripsForm.value.weight || this.truckWeight,
        this.tripsForm.value.vehcl_no || this.vehicleNumber,
        this.tripsForm.value.trip_id || this.tripId,
        this.tripsForm.value.trip_status || this.tripStatus,
        this.download,
        this.perPage,
        this.page
      );
    }
    if (this.tripsForm.value.trip_id) {
      this.tripsReports(
        this.tripsForm.value.from_loc || this.fromLocation,
        this.tripsForm.value.to_loc || this.toLocation,
        formattedFromDate,
        formattedToDate,
        this.tripsForm.value.veh_cat || this.truckCategory,
        this.tripsForm.value.weight || this.truckWeight,
        this.tripsForm.value.vehcl_no || this.vehicleNumber,
        this.tripsForm.value.trip_id || this.tripId,
        this.tripsForm.value.trip_status || this.tripStatus,
        this.download,
        this.perPage,
        this.page
      );
    }
    if (this.tripsForm.value.vehcl_no) {
      this.tripsReports(
        this.tripsForm.value.from_loc || this.fromLocation,
        this.tripsForm.value.to_loc || this.toLocation,
        formattedFromDate,
        formattedToDate,
        this.tripsForm.value.veh_cat || this.truckCategory,
        this.tripsForm.value.weight || this.truckWeight,
        this.tripsForm.value.vehcl_no || this.vehicleNumber,
        this.tripsForm.value.trip_id || this.tripId,
        this.tripsForm.value.trip_status || this.tripStatus,
        this.download,
        this.perPage,
        this.page
      );
    }
    if (this.tripsForm.value.veh_cat) {
      this.tripsReports(
        this.tripsForm.value.from_loc || this.fromLocation,
        this.tripsForm.value.to_loc || this.toLocation,
        formattedFromDate,
        formattedToDate,
        this.tripsForm.value.veh_cat || this.truckCategory,
        this.tripsForm.value.weight || this.truckWeight,
        this.tripsForm.value.vehcl_no || this.vehicleNumber,
        this.tripsForm.value.trip_id || this.tripId,
        this.tripsForm.value.trip_status || this.tripStatus,
        this.download,
        this.perPage,
        this.page
      );
    }
    if (this.tripsForm.value.weight) {
      this.tripsReports(
        this.tripsForm.value.from_loc || this.fromLocation,
        this.tripsForm.value.to_loc || this.toLocation,
        formattedFromDate,
        formattedToDate,
        this.tripsForm.value.veh_cat || this.truckCategory,
        this.tripsForm.value.weight || this.truckWeight,
        this.tripsForm.value.vehcl_no || this.vehicleNumber,
        this.tripsForm.value.trip_id || this.tripId,
        this.tripsForm.value.trip_status || this.tripStatus,
        this.download,
        this.perPage,
        this.page
      );
    }
    if (this.tripsForm.value.trip_status) {
      this.tripsReports(
        this.tripsForm.value.from_loc || this.fromLocation,
        this.tripsForm.value.to_loc || this.toLocation,
        formattedFromDate,
        formattedToDate,
        this.tripsForm.value.veh_cat || this.truckCategory,
        this.tripsForm.value.weight || this.truckWeight,
        this.tripsForm.value.vehcl_no || this.vehicleNumber,
        this.tripsForm.value.trip_id || this.tripId,
        this.tripsForm.value.trip_status || this.tripStatus,
        this.download,
        this.perPage,
        this.page
      );
    }
  }

  applyTrucksFilter() {
    this.document_array = [];
    this.isSearchDisabled = true;
    this.page = 1;
    this.truckStartPage = 1;

    this.truck_fetch_page = 1;
    if (this.trucksForm.value.veh_cat) {
      this.trucksReports(
        this.fromLocation,
        this.toLocation,
        this.fromDate,
        this.toDate,
        this.trucksForm.value.veh_cat || this.truckCategory,
        this.trucksForm.value.feet || this.truckFeet,
        this.trucksForm.value.weight || this.truckWeight,
        this.trucksForm.value.veh_status || this.vehicleStatus,
        this.trucksForm.value.truckowner_name || this.truckOwner,
        this.download,
        this.truckNumber,
        this.perPage,
        this.page
      );
    }
    if (this.trucksForm.value.feet) {
      this.trucksReports(
        this.fromLocation,
        this.toLocation,
        this.fromDate,
        this.toDate,
        this.trucksForm.value.veh_cat || this.truckCategory,
        this.trucksForm.value.feet || this.truckFeet,
        this.trucksForm.value.weight || this.truckWeight,
        this.trucksForm.value.veh_status || this.vehicleStatus,
        this.trucksForm.value.truckowner_name || this.truckOwner,
        this.download,
        this.truckNumber,
        this.perPage,
        this.page
      );
    }
    if (this.trucksForm.value.weight) {
      this.trucksReports(
        this.fromLocation,
        this.toLocation,
        this.fromDate,
        this.toDate,
        this.trucksForm.value.veh_cat || this.truckCategory,
        this.trucksForm.value.feet || this.truckFeet,
        this.trucksForm.value.weight || this.truckWeight,
        this.trucksForm.value.veh_status || this.vehicleStatus,
        this.trucksForm.value.truckowner_name || this.truckOwner,
        this.download,
        this.truckNumber,
        this.perPage,
        this.page
      );
    }
    if (this.trucksForm.value.weight) {
      this.trucksReports(
        this.fromLocation,
        this.toLocation,
        this.fromDate,
        this.toDate,
        this.trucksForm.value.veh_cat || this.truckCategory,
        this.trucksForm.value.feet || this.truckFeet,
        this.trucksForm.value.weight || this.truckWeight,
        this.trucksForm.value.veh_status || this.vehicleStatus,
        this.trucksForm.value.truckowner_name || this.truckOwner,
        this.download,
        this.truckNumber,
        this.perPage,
        this.page
      );
    }
    if (this.trucksForm.value.veh_status) {
      this.trucksReports(
        this.fromLocation,
        this.toLocation,
        this.fromDate,
        this.toDate,
        this.trucksForm.value.veh_cat || this.truckCategory,
        this.trucksForm.value.feet || this.truckFeet,
        this.trucksForm.value.weight || this.truckWeight,
        this.trucksForm.value.veh_status || this.vehicleStatus,
        this.trucksForm.value.truckowner_name || this.truckOwner,
        this.download,
        this.truckNumber,
        this.perPage,
        this.page
      );
    }
    if (this.trucksForm.value.truckowner_name) {
      this.trucksReports(
        this.fromLocation,
        this.toLocation,
        this.fromDate,
        this.toDate,
        this.trucksForm.value.veh_cat || this.truckCategory,
        this.trucksForm.value.feet || this.truckFeet,
        this.trucksForm.value.weight || this.truckWeight,
        this.trucksForm.value.veh_status || this.vehicleStatus,
        this.trucksForm.value.truckowner_name || this.truckOwner,
        this.download,
        this.truckNumber,
        this.perPage,
        this.page
      );
    }
  }

  applyDriversFilter() {
    this.document_array = [];
    this.isSearchDisabled = true;
    this.page = 1;
    this.driverStartPage = 1;
    this.drivers_fetch_page = 1;
    this.driverIdKeyword = -1;
    this.driverName = -1;
    if (this.driversForm.value.truckNumber) {
      this.driversReports(
        this.driversForm.value.truckNumber || this.truckNo,
        this.truckOwnerName,
        this.driversForm.value.driverStatus || this.driverStatus,
        this.download,
        this.driverIdKeyword || this.driverName,
        this.driver_status,
        this.perPage,
        this.page
      );
    }
    if (this.driversForm.value.driverStatus) {
      this.driversReports(
        this.driversForm.value.truckNumber || this.truckNo,
        this.truckOwnerName,
        this.driversForm.value.driverStatus || this.driverStatus,
        this.download,
        this.driverIdKeyword || this.driverName,
        this.driver_status,
        this.perPage,
        this.page
      );
    }
  }

  applyWorkOrderFilter() {
    // this.download = this.downloadReports;
    this.isSearchDisabled = true;
    this.workorder_fetch_page = 1;
    this.document_array = [];
    this.page = 1;
    if (this.workOrderForm.value.salese_Order_Number) {
      this.workordersReports(
        this.workOrderForm.value.salese_Order_Number || this.salesOrderNo,
        this.workOrderForm.value.from_date || this.fromDate,
        this.workOrderForm.value.to_date || this.toDate,
        this.workOrderForm.value.work_Order_Number || this.workorder_no,
        this.download,
        this.customerName,
        this.perPage,
        this.page
      );
    }
    if (this.workOrderForm.value.work_Order_Number) {
      this.workordersReports(
        this.workOrderForm.value.salese_Order_Number || this.salesOrderNo,
        this.workOrderForm.value.from_date || this.fromDate,
        this.workOrderForm.value.to_date || this.toDate,
        this.workOrderForm.value.work_Order_Number || this.workorder_no,
        this.download,
        this.customerName,
        this.perPage,
        this.page
      );
    }
  }

  applyTransporter() {
    this.document_array = [];

    this.page = 1;
    this.isSearchDisabled = true;
    this.transportStartPage = 1;
    this.transport_fetch_page = 1;
    // this.download = this.downloadReports;
    // Get date values from form
    const fromDateValue = this.transportForm.value.from_date;
    const toDateValue = this.transportForm.value.to_date;

    // Initialize formatted dates to -1
    let formattedFromDate = "-1";
    let formattedToDate = "-1";

    // Check if fromDateValue is valid and not empty
    if (fromDateValue) {
      const parsedFromDate = new Date(fromDateValue);
      if (!isNaN(parsedFromDate.getTime())) {
        formattedFromDate = formatDate(parsedFromDate, "yyyy-MM-dd", "en");
      }
    }

    // Check if toDateValue is valid and not empty
    if (toDateValue) {
      const parsedToDate = new Date(toDateValue);
      if (!isNaN(parsedToDate.getTime())) {
        formattedToDate = formatDate(parsedToDate, "yyyy-MM-dd", "en");
      }
    }

    if (this.transportForm.get("to_date")?.enabled && !toDateValue) {
      this.snackBar.open("Please select To Date", "Close", {
        duration: 2000,
      });
      return;
    }
    if (this.transportForm.value.from_date) {
      this.transporterReports(
        this.transportForm.value.sales_order || this.salesOrderNo,
        this.workOrderNo,
        this.transportForm.value.truckowner_name || this.truckNumber,
        this.truckNo,
        formattedFromDate,
        formattedToDate,
        this.transportForm.value.trip_id || this.tripId,
        this.download,
        this.perPage,
        this.transportStartPage
      );
    }
    if (this.transportForm.value.to_date) {
      this.transporterReports(
        this.transportForm.value.sales_order || this.salesOrderNo,
        this.workOrderNo,
        this.transportForm.value.truckowner_name || this.truckNumber,
        this.truckNo,
        formattedFromDate,
        formattedToDate,
        this.transportForm.value.trip_id || this.tripId,
        this.download,
        this.perPage,
        this.transportStartPage
      );
    }
    if (this.transportForm.value.trip_id) {
      this.transporterReports(
        this.transportForm.value.sales_order || this.salesOrderNo,
        this.workOrderNo,
        this.transportForm.value.truckowner_name || this.truckNumber,
        this.truckNo,
        formattedFromDate,
        formattedToDate,
        this.transportForm.value.trip_id || this.tripId,
        this.download,
        this.perPage,
        this.transportStartPage
      );
    }
    if (this.transportForm.value.sales_order) {
      this.transporterReports(
        this.transportForm.value.sales_order || this.salesOrderNo,
        this.workOrderNo,
        this.transportForm.value.truckowner_name || this.truckNumber,
        this.truckNo,
        formattedFromDate,
        formattedToDate,
        this.transportForm.value.trip_id || this.tripId,
        this.download,
        this.perPage,
        this.transportStartPage
      );
    }
    if (this.transportForm.value.truckowner_name) {
      this.transporterReports(
        this.transportForm.value.sales_order || this.salesOrderNo,
        this.workOrderNo,
        this.transportForm.value.truckowner_name || this.truckNumber,
        this.truckNo,
        formattedFromDate,
        formattedToDate,
        this.transportForm.value.trip_id || this.tripId,
        this.download,
        this.perPage,
        this.transportStartPage
      );
    }
  }

  applyOrdersFilter() {
    // this.download = this.downloadReports;
    this.document_array = [];

    this.page = 1;
    this.orders_fetch_page = 1;
    this.isSearchDisabled = true;
    this.ordersStartPage = 1;
    // Get date values from form
    const fromDateValue = this.ordersForm.value.from_date;
    const toDateValue = this.ordersForm.value.to_date;

    // Initialize formatted dates to -1
    let formattedFromDate = "-1";
    let formattedToDate = "-1";

    // Check if fromDateValue is valid and not empty
    if (fromDateValue) {
      const parsedFromDate = new Date(fromDateValue);
      if (!isNaN(parsedFromDate.getTime())) {
        formattedFromDate = formatDate(parsedFromDate, "yyyy-MM-dd", "en");
      }
    }

    // Check if toDateValue is valid and not empty
    if (toDateValue) {
      const parsedToDate = new Date(toDateValue);
      if (!isNaN(parsedToDate.getTime())) {
        formattedToDate = formatDate(parsedToDate, "yyyy-MM-dd", "en");
      }
    }

    if (this.ordersForm.get("to_date")?.enabled && !toDateValue) {
      this.snackBar.open("Please select To Date", "Close", {
        duration: 2000,
      });
      return;
    }

    if (this.ordersForm.value.from_date) {
      this.ordersReports(
        this.ordersForm.value.from_loc || this.fromLocation,
        this.ordersForm.value.to_loc || this.toLocation,
        formattedFromDate,
        formattedToDate,
        this.ordersForm.value.veh_cat || this.truckCategory,
        this.ordersForm.value.trip_id || this.tripId,
        this.ordersForm.value.weight || this.truckWeight,
        this.ordersForm.value.pay_status || this.orderStatus,
        this.ordersForm.value.truckowner_name || this.truckOwner,
        this.download,
        this.perPage,
        this.page
      );
    }
    if (this.ordersForm.value.to_date) {
      this.ordersReports(
        this.ordersForm.value.from_loc || this.fromLocation,
        this.ordersForm.value.to_loc || this.toLocation,
        formattedFromDate,
        formattedToDate,
        this.ordersForm.value.veh_cat || this.truckCategory,
        this.ordersForm.value.trip_id || this.tripId,
        this.ordersForm.value.weight || this.truckWeight,
        this.ordersForm.value.pay_status || this.orderStatus,
        this.ordersForm.value.truckowner_name || this.truckOwner,
        this.download,
        this.perPage,
        this.page
      );
    }
    if (this.ordersForm.value.from_loc) {
      this.ordersReports(
        this.ordersForm.value.from_loc || this.fromLocation,
        this.ordersForm.value.to_loc || this.toLocation,
        formattedFromDate,
        formattedToDate,
        this.ordersForm.value.veh_cat || this.truckCategory,
        this.ordersForm.value.trip_id || this.tripId,
        this.ordersForm.value.weight || this.truckWeight,
        this.ordersForm.value.pay_status || this.orderStatus,
        this.ordersForm.value.truckowner_name || this.truckOwner,
        this.download,
        this.perPage,
        this.page
      );
    }
    if (this.ordersForm.value.to_loc) {
      this.ordersReports(
        this.ordersForm.value.from_loc || this.fromLocation,
        this.ordersForm.value.to_loc || this.toLocation,
        formattedFromDate,
        formattedToDate,
        this.ordersForm.value.veh_cat || this.truckCategory,
        this.ordersForm.value.trip_id || this.tripId,
        this.ordersForm.value.weight || this.truckWeight,
        this.ordersForm.value.pay_status || this.orderStatus,
        this.ordersForm.value.truckowner_name || this.truckOwner,
        this.download,
        this.perPage,
        this.page
      );
    }
    if (this.ordersForm.value.trip_id) {
      this.ordersReports(
        this.ordersForm.value.from_loc || this.fromLocation,
        this.ordersForm.value.to_loc || this.toLocation,
        formattedFromDate,
        formattedToDate,
        this.ordersForm.value.veh_cat || this.truckCategory,
        this.ordersForm.value.trip_id || this.tripId,
        this.ordersForm.value.weight || this.truckWeight,
        this.ordersForm.value.pay_status || this.orderStatus,
        this.ordersForm.value.truckowner_name || this.truckOwner,
        this.download,
        this.perPage,
        this.page
      );
    }
    if (this.ordersForm.value.veh_cat) {
      this.ordersReports(
        this.ordersForm.value.from_loc || this.fromLocation,
        this.ordersForm.value.to_loc || this.toLocation,
        formattedFromDate,
        formattedToDate,
        this.ordersForm.value.veh_cat || this.truckCategory,
        this.ordersForm.value.trip_id || this.tripId,
        this.ordersForm.value.weight || this.truckWeight,
        this.ordersForm.value.pay_status || this.orderStatus,
        this.ordersForm.value.truckowner_name || this.truckOwner,
        this.download,
        this.perPage,
        this.page
      );
    }
    if (this.ordersForm.value.pay_status) {
      this.ordersReports(
        this.ordersForm.value.from_loc || this.fromLocation,
        this.ordersForm.value.to_loc || this.toLocation,
        formattedFromDate,
        formattedToDate,
        this.ordersForm.value.veh_cat || this.truckCategory,
        this.ordersForm.value.trip_id || this.tripId,
        this.ordersForm.value.weight || this.truckWeight,
        this.ordersForm.value.pay_status || this.orderStatus,
        this.ordersForm.value.truckowner_name || this.truckOwner,
        this.download,
        this.perPage,
        this.page
      );
    }
    if (this.ordersForm.value.weight) {
      this.ordersReports(
        this.ordersForm.value.from_loc || this.fromLocation,
        this.ordersForm.value.to_loc || this.toLocation,
        formattedFromDate,
        formattedToDate,
        this.ordersForm.value.veh_cat || this.truckCategory,
        this.ordersForm.value.trip_id || this.tripId,
        this.ordersForm.value.weight || this.truckWeight,
        this.ordersForm.value.pay_status || this.orderStatus,
        this.ordersForm.value.truckowner_name || this.truckOwner,
        this.download,
        this.perPage,
        this.page
      );
    }
    if (this.ordersForm.value.truckowner_name) {
      this.ordersReports(
        this.ordersForm.value.from_loc || this.fromLocation,
        this.ordersForm.value.to_loc || this.toLocation,
        formattedFromDate,
        formattedToDate,
        this.ordersForm.value.veh_cat || this.truckCategory,
        this.ordersForm.value.trip_id || this.tripId,
        this.ordersForm.value.weight || this.truckWeight,
        this.ordersForm.value.pay_status || this.orderStatus,
        this.ordersForm.value.truckowner_name || this.truckOwner,
        this.download,
        this.perPage,
        this.page
      );
    }
  }

  tripspagination(page_status: any) {
    if (page_status == "-1") {
      this.trips_fetch_page = parseInt(this.trips_fetch_page) - 1;
      this.currentPage = this.trips_fetch_page;
      this.tripsStartPage = this.currentPage;
    }
    if (page_status == "1") {
      this.currentPage = parseInt(this.trips_fetch_page) + 1;
      this.trips_fetch_page = this.currentPage;
      this.tripsStartPage = this.trips_fetch_page;
    }
    if (page_status == "first") {
      this.trips_fetch_page = this.document_array[0].currentPage;
      this.tripsStartPage = this.document_array[0].currentPage;
    }
    if (page_status == "last") {
      this.trips_fetch_page = this.document_array[0].lastPage;
      this.tripsStartPage = this.document_array[0].lastPage;
    }

    // Get date values from form
    const fromDateValue = this.tripsForm.value.from_date;
    const toDateValue = this.tripsForm.value.to_date;

    // Initialize formatted dates to -1
    let formattedFromDate = "-1";
    let formattedToDate = "-1";

    // Check if fromDateValue is valid and not empty
    if (fromDateValue) {
      const parsedFromDate = new Date(fromDateValue);
      if (!isNaN(parsedFromDate.getTime())) {
        formattedFromDate = formatDate(parsedFromDate, "yyyy-MM-dd", "en");
      }
    }

    // Check if toDateValue is valid and not empty
    if (toDateValue) {
      const parsedToDate = new Date(toDateValue);
      if (!isNaN(parsedToDate.getTime())) {
        formattedToDate = formatDate(parsedToDate, "yyyy-MM-dd", "en");
      }
    }

    this.tripsReports(
      this.tripsForm.value.from_loc || this.fromLocation,
      this.tripsForm.value.to_loc || this.toLocation,
      formattedFromDate,
      formattedToDate,
      this.tripsForm.value.veh_cat || this.truckCategory,
      this.tripsForm.value.weight || this.truckWeight,
      this.tripsForm.value.veh_no || this.vehicleNumber,
      this.tripsForm.value.trip_id || this.tripId,
      this.tripsForm.value.trip_status || this.tripStatus,
      this.download,
      this.perPage,
      this.page
    );
  }

  todoSearch(value: string) {
    if (value.length <= 2) {
      this.snackBar.open("Please enter at least 3 characters", "Fail", {
        duration: 3000,
      });
      return;
    }
    if (value != "") {
      this.isApplyButtonDisabled = true;
      this.isSearching = false;
      this.page = 1;
      this.todo_fetch_page = 1;
      this.todoStartPage = 1;
      let todoIdKeyword = value || this.tripId;
      this.todoReports(
        this.todoForm.value.fromDate || this.fromDate,
        this.todoForm.value.to_date || this.toDate,
        this.todoForm.value.trip_status || this.tripStatus,
        this.todoForm.value.trip_id || todoIdKeyword,
        this.todoForm.value.bank_name
          ? this.todoForm.value.bank_name.toUpperCase()
          : this.bankName,
        this.todoForm.value.truck_no || this.truckNo,
        this.download,
        this.perPage,
        this.page
      );
    }
  }

  onInputChange(value: any, event: any) {
    if (value.length === 0 && event == "todo") {
      this.clearSearch("todo");
    } else if (value.length === 0 && event === "quotes") {
      this.clearSearch("quotes");
    } else if (value.length === 0 && event === "trips") {
      this.clearSearch("trips");
    } else if (value.length === 0 && event === "payments") {
      this.clearSearch("payments");
    } else if (value.length === 0 && event === "trucks") {
      this.clearSearch("trucks");
    } else if (value.length === 0 && event === "drivers") {
      this.clearSearch("drivers");
    } else if (value.length === 0 && event === "orders") {
      this.clearSearch("orders");
    } else if (value.length === 0 && event === "corporate") {
      this.clearSearch("corporate");
    } else if (value.length === 0 && event === "transporter") {
      this.clearSearch("transporter");
    } else if (value.length === 0 && event === "workorders") {
      this.clearSearch("workorders");
    } else if (value.length === 0 && event === "preorder") {
      this.clearSearch("preorder");
    } else if (value.length === 0 && event === "preorders1") {
      this.clearSearch("preorders1");
    }
  }

  transformToUppercaseTodo(event: any) {
    event.target.value = event.target.value.toUpperCase();
    const enteredValue = event.target.value;
    if (enteredValue.length >= 2 && this.isSearching === false) {
      this.isSearching = true;
      this.todoReport = true;
      this.todoReports(
        this.fromDate,
        this.toDate,
        this.tripStatus,
        this.tripId,
        this.bankName,
        this.truckNo,
        this.download,
        this.perPage,
        this.page
      );
    }
  }

  transformToUppercaseQuote(event: any) {
    event.target.value = event.target.value.toUpperCase();
    const enteredValue = event.target.value;
    if (enteredValue.length >= 2 && this.isSearching === false) {
      this.isSearching = true;
      this.quotesReport = true;
      this.quotesReports(
        this.fromLocation,
        this.toLocation,
        this.fromDate,
        this.toDate,
        this.truckCategory,
        this.tripId,
        this.download,
        this.perPage,
        this.quoteStartPage,
        this.report_status
      );
    }
  }

  transformToUppercaseTrips(event: any) {
    event.target.value = event.target.value.toUpperCase();
    const enteredValue = event.target.value;
    if (enteredValue == "" || enteredValue == null) {
      this.trips_fetch_page = 1;
      this.tripsReports(
        this.fromLocation,
        this.toLocation,
        this.fromDate,
        this.toDate,
        this.truckCategory,
        this.truckWeight,
        this.vehicleNumber,
        this.tripId,
        this.tripStatus,
        this.download,
        this.perPage,
        this.page
      );
    }
    if (enteredValue.length >= 2 && this.isSearching === false) {
      this.isSearching = true;
      this.tripsReport = true;
      this.trips_fetch_page = 1;
      this.tripsReports(
        this.fromLocation,
        this.toLocation,
        this.fromDate,
        this.toDate,
        this.truckCategory,
        this.truckWeight,
        this.vehicleNumber,
        this.tripId,
        this.tripStatus,
        this.download,
        this.perPage,
        this.page
      );
    }
  }
  transformToUppercasePayments(event: any) {
    event.target.value = event.target.value.toUpperCase();
    const enteredValue = event.target.value;
    if (enteredValue.length >= 2 && this.isSearching === false) {
      this.payment_fetch_page = 1;
      this.isSearching = true;
      this.todoReport = true;
      this.paymentsReports(
        this.fromLocation,
        this.toLocation,
        this.fromDate,
        this.toDate,
        this.paymentStatus,
        this.tripId,
        this.download,
        this.perPage,
        this.paymentPage
      );
    }
  }

  transformToUppercaseTrucks(event: any) {
    event.target.value = event.target.value.toUpperCase();
    const enteredValue = event.target.value;
    if (enteredValue.length >= 2 && this.isSearching === false) {
      this.isSearching = true;
      this.todoReport = true;
      this.trucksReports(
        this.fromLocation,
        this.toLocation,
        this.fromDate,
        this.toDate,
        this.truckCategory,
        this.truckFeet,
        this.truckWeight,
        this.vehicleStatus,
        this.truckOwner,
        this.download,
        this.truckNumber,
        this.perPage,
        this.page
      );
    }
  }

  transformToUppercaseDrivers(event: any) {
    event.target.value = event.target.value;
    const enteredValue = event.target.value;
    if (enteredValue.length >= 2 && this.isSearching === false) {
      this.isSearching = true;
      this.todoReport = true;
      this.drivers_fetch_page = 1;
      this.driversReports(
        this.truckNo,
        this.truckOwnerName,
        this.driverStatus,
        this.download,
        this.driverName,
        this.driver_status,
        this.perPage,
        this.page
      );
    }
  }
  transformToUppercaseOrders(event: any) {
    event.target.value = event.target.value.toUpperCase();
    const enteredValue = event.target.value;
    if (enteredValue.length >= 2 && this.isSearching === false) {
      this.isSearching = true;
      this.todoReport = true;
      this.orders_fetch_page = 1;
      this.ordersReports(
        this.fromLocation,
        this.toLocation,
        this.fromDate,
        this.toDate,
        this.truckCategory,
        this.tripId,
        this.truckWeight,
        this.orderStatus,
        this.truckOwner,
        this.download,
        this.perPage,
        this.page
      );
    }
  }
  transformToUppercaseCorporate(event: any) {
    event.target.value = event.target.value.toUpperCase();
    const enteredValue = event.target.value;
    if (enteredValue.length >= 2 && this.isSearching === false) {
      this.isSearching = true;
      this.customerReport = true;
      this.isNoRecordsFound = false;
      this.searchQuery = -1;
      this.corporate_fetch_page = 1;
      this.corporate_customer = 1;
      this.corporateStartPage = 1;
      this.getReportsCustomer(
        this.searchQuery,
        this.perPage,
        this.corporateStartPage
      );
    }
  }
  transformToUppercaseCorporateCustomer(event: any) {
    event.target.value = event.target.value.toUpperCase();
    const enteredValue = event.target.value;
    if (enteredValue.length >= 2 && this.isSearching === false) {
      this.isNoRecordsFound = false;
      this.isSearching = true;
      this.customerReport = false;
      this.corporate_fetch_page = 1;
      this.customer(
        this.fromDate,
        this.toDate,
        this.fromLocation,
        this.toLocation,
        this.salesOrderNo,
        this.workOrderNo,
        this.tripId,
        this.lrNo,
        this.vchlNo,
        this.download,
        this.perPage,
        this.page
      );
    }
  }

  transformToUppercaseTransporter(event: any) {
    event.target.value = event.target.value;
    const enteredValue = event.target.value;
    if (enteredValue.length >= 1 && this.isSearching === false) {
      this.isSearching = true;
      this.transporterReport = true;
      this.transportStartPage = 1;
      this.transport_fetch_page = 1;
      this.transporterReports(
        this.salesOrderNo,
        this.workOrderNo,
        this.truckOwnerName,
        this.truckNo,
        this.fromDate,
        this.toDate,
        this.tripId,
        this.download,
        this.perPage,
        this.transportStartPage
      );
    }
  }
  transformToUppercaseWO(event: any) {
    event.target.value = event.target.value.toUpperCase();
    const enteredValue = event.target.value;
    if (enteredValue.length >= 2 && this.isSearching === false) {
      this.isSearching = true;
      this.workOrdersReports = true;
      this.workStartPage = 1;
      this.workorder_fetch_page = 1;
      this.workordersReports(
        this.fromDate,
        this.toDate,
        this.salesOrderNo,
        this.workorder_no,
        this.download,
        this.customerName,
        this.perPage,
        this.workStartPage
      );
    }
  }

  quoteSearch(value: string) {
    if (value.length <= 2) {
      this.snackBar.open("Please enter at least 3 characters", "Fail", {
        duration: 3000,
      });
      return;
    }
    if (value != "") {
      this.page = 1;
      this.quoteStartPage = 1;
      this.fetch_page = 1;
      this.isApplyButtonDisabled = true;
      this.isSearching = false;
      let quotesIdKeyword = value || this.quotesId;
      this.quotesReports(
        this.quotesForm.value.from_date || this.fromDate,
        this.quotesForm.value.to_date || this.toDate,
        this.quotesForm.value.from_loc || this.fromLocation,
        this.quotesForm.value.to_loc || this.toLocation,
        this.quotesForm.value.truck_categ || this.truckCategory,
        this.quotesForm.value.quote_id || quotesIdKeyword,
        this.download,
        this.perPage,
        this.quoteStartPage,
        this.report_status
      );
    }
  }

  clearSearch(item: any) {
    this.isSearching = true;
    this.isApplyButtonDisabled = false;
    if (this.newid) {
      if (item == "todo") {
        this.todoReport = true;
        this.newid.nativeElement.value = "";
        this.todoReports(
          this.fromDate,
          this.toDate,
          this.tripStatus,
          this.tripId,
          this.bankName,
          this.truckNo,
          this.download,
          this.perPage,
          this.page
        );
      }
    }
    if (this.newItem) {
      if (item == "quotes") {
        this.quotesReport = true;
        this.newItem.nativeElement.value = "";
        this.quotesReports(
          this.fromLocation,
          this.toLocation,
          this.fromDate,
          this.toDate,
          this.truckCategory,
          this.tripId,
          this.download,
          this.perPage,
          this.quoteStartPage,
          this.report_status
        );
      }
    }
    if (this.tripsTab) {
      if (item == "trips") {
        this.tripsReport = true;
        this.tripsTab.nativeElement.value = "";
        this.tripsReports(
          this.fromLocation,
          this.toLocation,
          this.fromDate,
          this.toDate,
          this.truckCategory,
          this.truckWeight,
          this.vehicleNumber,
          this.tripId,
          this.tripStatus,
          this.download,
          this.perPage,
          this.page
        );
      }
    }
    if (this.paymentTab) {
      if (item == "payments") {
        this.paymentsReport = true;
        this.paymentTab.nativeElement.value = "";
        this.paymentsReports(
          this.fromLocation,
          this.toLocation,
          this.fromDate,
          this.toDate,
          this.paymentStatus,
          this.tripId,
          this.download,
          this.perPage,
          this.paymentPage
        );
      }
    }
    if (this.trucksTab) {
      if (item == "trucks") {
        this.TrucksReports = true;
        this.trucksTab.nativeElement.value = "";
        this.trucksReports(
          this.fromLocation,
          this.toLocation,
          this.fromDate,
          this.toDate,
          this.truckCategory,
          this.truckWeight,
          this.vehicleNumber,
          this.tripId,
          this.tripStatus,
          this.download,
          this.truckNumber,
          this.perPage,
          this.report_status,
          this.truckStartPage
        );
      }
    }
    if (this.driverTab) {
      if (item == "drivers") {
        this.DriversReports = true;
        this.driverTab.nativeElement.value = "";
        this.driverIdKeyword = -1;
        this.driversReports(
          this.truckNo,
          this.truckOwnerName,
          this.driverStatus,
          this.download,
          this.driverName,
          this.driver_status,
          this.perPage,
          this.page
        );
      }
    }
    if (this.orderTab) {
      if (item == "orders") {
        this.OrdersReports = true;
        this.orderTab.nativeElement.value = "";
        this.ordersReports(
          this.fromLocation,
          this.toLocation,
          this.fromDate,
          this.toDate,
          this.truckCategory,
          this.tripId,
          this.truckWeight,
          this.orderStatus,
          this.truckOwner,
          this.download,
          this.perPage,
          this.page
        );
      }
    }
    if (this.transporterTab) {
      if (item == "transporter") {
        this.transporterReport = true;
        this.transportStartPage = 1;
        this.transport_fetch_page = 1;
        this.transporterTab.nativeElement.value = "";
        this.transporterIdKeyword = -1;
        this.transporterReports(
          this.salesOrderNo,
          this.workOrderNo,
          this.transportForm.value.truckowner_name || this.truckNumber,
          this.truckNo,
          this.fromDate,
          this.toDate,
          this.tripId,
          this.download,
          this.perPage,
          this.transportStartPage
        );
      }
    }
    if (this.newItemWO) {
      if (item == "workorders") {
        this.workOrdersReports = true;
        this.newItemWO.nativeElement.value = "";
        this.workordersReports(
          this.fromDate,
          this.toDate,
          this.salesOrderNo,
          this.workorder_no,
          this.download,
          this.customerName,
          this.perPage,
          this.page
        );
      }
    }
    if (this.corporateTab) {
      if (item == "corporate") {
        this.page = 1;
        this.corporate_customer = 1;
        this.searchQuery = -1;
        this.document_array = [];
        this.corporateTab.nativeElement.value = "";
        this.customerReport = true;
        this.isNoRecordsFound = false;
        this.getReportsCustomer(this.searchQuery, this.perPage, this.page);
      }
      if (item == "corporateCustomer") {
        this.page = 1;
        this.corporate_fetch_page = 1;
        this.document_array = [];
        this.customerReport = true;
        this.isNoRecordsFound = false;
        this.corporateTab.nativeElement.value = "";
        this.customer(
          this.fromDate,
          this.toDate,
          this.fromLocation,
          this.toLocation,
          this.salesOrderNo,
          this.workOrderNo,
          this.tripId,
          this.lrNo,
          this.vchlNo,
          this.download,
          this.perPage,
          this.page
        );
      }
    }
    if (this.newItemPreorder) {
      if (item == "preorder") {
        this.preOrderReports = true;
        this.newItemPreorder.nativeElement.value = "";
        this.preordersReports(
          this.fromLocation,
          this.toLocation,
          this.fromDate,
          this.toDate,
          this.truckCategory,
          this.download,
          this.woid,
          this.perPage,
          this.page
        );
      }
    }
    if (this.newItemPreorder1) {
      if (item == "preorders1") {
        this.preOrderReports = true;
        this.newItemPreorder1.nativeElement.value = "";
        this.preordersReports1(
          this.selectedPreOrderId,
          this.fromLocation,
          this.toLocation,
          this.userType,
          this.download,
          this.woid,
          this.perPage,
          this.page
        );
      }
    }
  }

  tripsSearch(value: string) {
    if (value.length <= 2) {
      this.snackBar.open("Please enter at least 3 characters", "Fail", {
        duration: 3000,
      });
      return;
    }
    if (value != "") {
      this.download = 1;
      this.isSearching = false;
      this.isApplyButtonDisabled = true;
      let tripsIdKeeyword = value || this.tripId;
      this.tripsStartPage = 1;
      this.tripsReports(
        this.tripsForm.value.from_date || this.fromDate,
        this.tripsForm.value.to_date || this.toDate,
        this.tripsForm.value.from_loc || this.fromLocation,
        this.tripsForm.value.to_loc || this.toLocation,
        this.tripsForm.value.veh_cat || this.truckCategory,
        this.tripsForm.value.weight || this.truckWeight,
        this.tripsForm.value.vehcl_no || this.vehicleNumber,
        this.tripsForm.value.trip_id || tripsIdKeeyword,
        this.tripsForm.value.trip_status || this.tripStatus,
        this.download,
        this.perPage,
        this.tripsStartPage
      );
    }
  }

  searchWorkOrder(value: string) {
    if (value.length <= 1) {
      this.snackBar.open("Please enter at least 2 characters", "Fail", {
        duration: 3000,
      });
      return;
    }
    if (value != "") {
      this.isSearching = false;
      this.isApplyButtonDisabled = true;
      this.workStartPage = 1;
      this.workorder_fetch_page = 1;
      let workorderIdKeyword = value || this.workOrderNo;
      this.workordersReports(
        this.fromDate,
        this.toDate,
        this.salesOrderNo,
        workorderIdKeyword,
        this.download,
        this.customerName,
        this.perPage,
        this.workStartPage
      );
    }
  }
  paymentSearch(value: string) {
    if (value.length <= 2) {
      this.snackBar.open("Please enter at least 3 characters", "Fail", {
        duration: 3000,
      });
      return;
    }
    if (value != "") {
      this.isSearching = false;
      this.isApplyButtonDisabled = true;
      this.paymentStartPage = 1;
      let paymentIdKeyword = value || this.tripId;
      this.paymentsReports(
        this.fromLocation,
        this.toLocation,
        this.fromDate,
        this.toDate,
        this.paymentStatus,
        paymentIdKeyword,
        this.download,
        this.perPage,
        this.paymentStartPage
      );
    }
  }

  truckSearch(value: string) {
    if (value.length <= 3) {
      this.snackBar.open("Please enter at least 4 characters", "Fail", {
        duration: 3000,
      });
      return;
    }
    if (value != "") {
      this.isSearching = false;
      this.download = 1;
      this.isApplyButtonDisabled = true;
      let truckIdKeyword = value || this.truckNumber;
      this.trucksReports(
        this.trucksForm.value.from_date || this.fromDate,
        this.trucksForm.value.to_date || this.toDate,
        this.trucksForm.value.from_loc || this.fromLocation,
        this.trucksForm.value.to_loc || this.toLocation,
        this.trucksForm.value.truck_categ || this.truckCategory,
        this.trucksForm.value.trip_id || this.tripId,
        this.truckWeight,
        this.tripStatus,
        this.vehicleNumber,
        this.download,
        truckIdKeyword,
        this.perPage,
        this.page,
        this.report_status
      );
    }
  }

  driverSearch(value: string) {
    if (value.length <= 3) {
      this.snackBar.open(
        "Please enter at least 4 characters or numbers",
        "Fail",
        {
          duration: 3000,
        }
      );
      return;
    }
    if (value != "") {
      this.isSearching = false;
      this.isApplyButtonDisabled = true;
      this.driverStartPage = 1;
      if (Number(value)) {
        this.driverIdKeyword = value.toUpperCase() || this.driver_status;
        var driver_name = this.driverName;
      } else {
        var driver_name = value.toUpperCase() || this.driverName;
        this.driverIdKeyword = this.driver_status;
      }

      this.download = 1;
      this.driversReports(
        this.truckNo,
        this.truckOwnerName,
        this.driverStatus,
        this.download,
        driver_name,
        this.driverIdKeyword,
        this.perPage,
        this.driverStartPage
      );
    }
  }

  orderSearch(value: string) {
    if (value.length <= 2) {
      this.snackBar.open("Please enter at least 3 characters", "Fail", {
        duration: 3000,
      });
      return;
    }
    if (value != "") {
      this.isSearching = false;
      this.ordersStartPage = 1;
      this.isApplyButtonDisabled = true;
      let orderIdKeyword = value || this.tripId;
      this.ordersReports(
        this.ordersForm.value.from_date || this.fromDate,
        this.ordersForm.value.to_date || this.toDate,
        this.ordersForm.value.from_loc || this.fromLocation,
        this.ordersForm.value.to_loc || this.toLocation,
        this.ordersForm.value.veh_cat || this.truckCategory,
        this.ordersForm.value.trip_id || orderIdKeyword,
        this.ordersForm.value.truckowner_name || this.truckOwner,
        this.truckWeight,
        this.vehicleNumber,
        this.download,
        this.perPage,
        this.page
      );
    }
  }

  searchCorporate(value: string) {
    if (value.length <= 2) {
      this.snackBar.open("Please enter at least 3 characters", "Fail", {
        duration: 3000,
      });
      return;
    }
    if (value != "") {
      this.isSearching = false;
      this.isApplyButtonDisabled = true;
      this.customerStartPage = 1;
      let corporateIdKeyword = value || this.tripId;
      this.customer(
        this.fromDate,
        this.toDate,
        this.fromLocation,
        this.toLocation,
        this.salesOrderNo,
        this.workOrderNo,
        corporateIdKeyword,
        this.lrNo,
        this.vchlNo,
        this.download,
        this.perPage,
        this.customerStartPage
      );
    }
  }

  searchCorporateCustomer(value: string) {
    if (value.length <= 3) {
      this.snackBar.open("Please enter at least 4 characters", "Fail", {
        duration: 3000,
      });
      return;
    }
    this.fetch_page = 1;
    this.corporateStartPage = 1;
    this.searchQuery = "";
    if (value != "") {
      this.isSearching = false;
      this.isApplyButtonDisabled = true;
      this.searchQuery = value;
      this.getReportsCustomer(this.searchQuery, this.perPage, this.fetch_page);
    }
  }

  transporterSearch(value: string) {
    if (value.length <= 4) {
      this.snackBar.open("Please enter at least 5 characters", "Fail", {
        duration: 3000,
      });
      return;
    }
    if (value != "") {
      this.document_array = [];
      this.isSearching = false;
      this.transportStartPage = 1;
      this.transport_fetch_page = 1;
      this.isApplyButtonDisabled = true;
      this.transportStartPage = 1;
      this.transporterIdKeyword = value.toUpperCase();
      this.transporterReports(
        this.salesOrderNo,
        this.workOrderNo,
        this.transporterIdKeyword || this.truckNumber,
        this.truckNo,
        this.fromDate,
        this.toDate,
        this.tripId,
        this.download,
        this.perPage,
        this.transportStartPage
      );
    }
  }

  corporatedownloadXl(corporatedownloadArray: string) {
    const fromDateValue = this.customerForm.value.from_date;
    const toDateValue = this.customerForm.value.to_date;

    // Initialize formatted dates to -1
    let formattedFromDate = "-1";
    let formattedToDate = "-1";

    // Check if fromDateValue is valid and not empty
    if (fromDateValue) {
      const parsedFromDate = new Date(fromDateValue);
      if (!isNaN(parsedFromDate.getTime())) {
        formattedFromDate = formatDate(parsedFromDate, "yyyy-MM-dd", "en");
      }
    }

    // Check if toDateValue is valid and not empty
    if (toDateValue) {
      const parsedToDate = new Date(toDateValue);
      if (!isNaN(parsedToDate.getTime())) {
        formattedToDate = formatDate(parsedToDate, "yyyy-MM-dd", "en");
      }
    }

    if (corporatedownloadArray === "") {
      this.download = this.downloadQuotes;
      let from = "Download";
      this.customer(
        formattedFromDate,
        formattedToDate,
        this.customerForm.value.from_loc || this.fromLocation,
        this.customerForm.value.to_loc || this.toLocation,
        this.customerForm.value.sales_order || this.salesOrderNo,
        this.customerForm.value.wo_no || this.workOrderNo,
        this.customerForm.value.trip_id || this.tripId,
        this.customerForm.value.lr_no || this.lrNo,
        this.customerForm.value.vehicle_no || this.vchlNo,
        this.download,
        this.perPage,
        this.page,
        from
      );
    } else {
      window.open(corporatedownloadArray, "_blank");
    }
  }

  tripdownloadXl(tripsdownloadArray: string) {
    const fromDateValue = this.tripsForm.value.from_date;
    const toDateValue = this.tripsForm.value.to_date;

    // Initialize formatted dates to -1
    let formattedFromDate = "-1";
    let formattedToDate = "-1";

    // Check if fromDateValue is valid and not empty
    if (fromDateValue) {
      const parsedFromDate = new Date(fromDateValue);
      if (!isNaN(parsedFromDate.getTime())) {
        formattedFromDate = formatDate(parsedFromDate, "yyyy-MM-dd", "en");
      }
    }

    // Check if toDateValue is valid and not empty
    if (toDateValue) {
      const parsedToDate = new Date(toDateValue);
      if (!isNaN(parsedToDate.getTime())) {
        formattedToDate = formatDate(parsedToDate, "yyyy-MM-dd", "en");
      }
    }
    if (tripsdownloadArray === "") {
      this.download = this.downloadQuotes;
      this.download = 1;

      let from = "Download";
      this.tripsReports(
        this.fromLocation,
        this.toLocation,
        fromDateValue,
        toDateValue,
        this.truckCategory,
        this.truckWeight,
        this.vehicleNumber,
        this.tripId,
        this.tripStatus,
        this.download,
        this.perPage,
        this.page,
        from
      );
    } else {
      window.open(tripsdownloadArray, "_blank");
    }
  }

  workorderdownloadXl(WodownloadArray: string) {
    if (WodownloadArray === "") {
      this.download = this.downloadQuotes;
      let from = "Download";
      this.workordersReports(
        this.fromDate,
        this.toDate,
        this.workOrderForm.value.salese_Order_Number || this.salesOrderNo,
        this.workOrderForm.value.work_Order_Number || this.workorder_no,
        this.download,
        this.customerName,
        this.perPage,
        this.page,
        from
      );
    } else {
      window.open(WodownloadArray, "_blank");
    }
  }

  transporterdownload(transporterdownloadArray: string) {
    // Get date values from form
    const fromDateValue = this.transportForm.value.from_date;
    const toDateValue = this.transportForm.value.to_date;

    // Initialize formatted dates to -1
    let formattedFromDate = "-1";
    let formattedToDate = "-1";

    // Check if fromDateValue is valid and not empty
    if (fromDateValue) {
      const parsedFromDate = new Date(fromDateValue);
      if (!isNaN(parsedFromDate.getTime())) {
        formattedFromDate = formatDate(parsedFromDate, "yyyy-MM-dd", "en");
      }
    }

    // Check if toDateValue is valid and not empty
    if (toDateValue) {
      const parsedToDate = new Date(toDateValue);
      if (!isNaN(parsedToDate.getTime())) {
        formattedToDate = formatDate(parsedToDate, "yyyy-MM-dd", "en");
      }
    }

    if (transporterdownloadArray === "") {
      // this.download = this.downloadQuotes;
      this.download = 1;
      this.transportStartPage = 1;
      let from = "Download";
      this.transporterReports(
        this.transportForm.value.sales_order || this.salesOrderNo,
        this.workOrderNo,
        this.transportForm.value.truckowner_name || this.truckNumber,
        this.truckNo,
        formattedFromDate,
        formattedToDate,
        this.transportForm.value.trip_id || this.tripId,
        this.download,
        this.perPage,
        this.transportStartPage,
        from
      );
    } else {
      this.download = 1;
      window.open(transporterdownloadArray, "_blank");
    }
  }

  getTotalLoadingPoint(tripsInfo: any[]): number {
    return tripsInfo?.reduce(
      (sum, trip) => sum + (trip.workOrderOtherDetails?.loading_point || 0),
      0
    );
  }
  getTotalUnLoadingPoint(tripsInfo: any[]): number {
    return tripsInfo?.reduce(
      (sum, trip) => sum + (trip.workOrderOtherDetails?.unloading_point || 0),
      0
    );
  }

  calculateTotalCost(workorders: any): number {
    const pricePerTon = workorders.price_per_ton || 1200; // Default price if not available

    if (workorders.pay_as_load_quantity === "loaded_quantity") {
      const totalLoadingPoints = this.getTotalLoadingPoint(
        workorders.tripsInfo
      );
      return totalLoadingPoints * pricePerTon;
    } else if (workorders.pay_as_load_quantity === "unloaded_quantity") {
      const totalUnloadingPoints = this.getTotalUnLoadingPoint(
        workorders.tripsInfo
      );
      return totalUnloadingPoints * pricePerTon;
    } else {
      return 0; // Default to 0 if `pay_as_load_quantity` is invalid
    }
  }

  getTripsInfoCount(tripsInfo: any): number {
    if (Array.isArray(tripsInfo)) {
      return tripsInfo.length; // Return the length of the array
    } else if (tripsInfo && typeof tripsInfo === "object") {
      return 1; // Return 1 if tripsInfo is a single object
    }
    return 0; // Return 0 if tripsInfo is undefined or empty
  }

  driReports(
    fromCity: any,
    toCity: any,
    fromDate: any,
    toDate: any,
    truckType: any,
    routeType: any,
    minFare: any,
    maxFare: any,
    download: any,
    perPage: any,
    page: any
  ) {
    this.driloading = true;
    let url = `/admin/report/driver-offline-routes?perPage=${perPage}&page=${page}`;
    if (fromCity && fromCity != -1) url += `&from_city=${fromCity}`;
    if (toCity && toCity != -1) url += `&to_city=${toCity}`;
    if (fromDate && fromDate != -1) {
      const parsedFromDate = new Date(fromDate);
      if (!isNaN(parsedFromDate.getTime())) {
        url += `&fromDate=${formatDate(parsedFromDate, "yyyy-MM-dd", "en-US")}`;
      }
    }
    if (toDate && toDate != -1) {
      const parsedToDate = new Date(toDate);
      if (!isNaN(parsedToDate.getTime())) {
        url += `&toDate=${formatDate(parsedToDate, "yyyy-MM-dd", "en-US")}`;
      }
    }
    if (truckType && truckType != -1) url += `&truck_type=${truckType}`;
    if (routeType && routeType != -1) url += `&route_type=${routeType}`;
    if (minFare && minFare != -1) url += `&min_fare=${minFare}`;
    if (maxFare && maxFare != -1) url += `&max_fare=${maxFare}`;

    this.services.getDriverOfflineRoutes(this.token, url).subscribe(
      (res: any) => {
        this.driArray = [];
        this.driloading = false;
        this.driArray = res.body.data;
        this.last_page = res.body.totalPages || 1;
        this.dridownloadArray = res.body.data;
        if (res.body.meta) {
          this.document_array.push(res.body.meta);
          this.last_page = res.body.meta.lastPage || this.last_page;
        }
      },
      (error) => {
        this.driloading = false;
        this.driArray = [];
        if (error.error && error.error.message) {
          this.snackBar.open(error.error.message, "Fail", {
            duration: 5000,
          });
        }
      }
    );
  }

  driPagination(page_status: any) {
    if (page_status == "1") {
      this.dri_fetch_page = this.dri_fetch_page + 1;
    }
    if (page_status == "-1") {
      this.dri_fetch_page = this.dri_fetch_page - 1;
    }
    if (page_status == "first") {
      this.dri_fetch_page = 1;
    }
    if (page_status == "last") {
      this.dri_fetch_page = this.last_page;
    }
    this.driReports(
      this.driForm.value.from_city,
      this.driForm.value.to_city,
      this.driForm.value.from_date,
      this.driForm.value.to_date,
      this.driForm.value.truck_type,
      this.driForm.value.route_type,
      this.driForm.value.min_fare,
      this.driForm.value.max_fare,
      -1,
      this.perPage,
      this.dri_fetch_page
    );
  }

  resetDRI() {
    this.dri_fetch_page = 1;
    this.driStartPage = 1;
    this.sortColumn = "";
    this.sortDirection = "asc";
    this.driForm.reset({
      route_type: "",
      truck_type: "",
      from_city: "",
      to_city: "",
      from_date: "",
      to_date: "",
      min_fare: "",
      max_fare: "",
    });

    if (this.driTab) {
      this.driTab.nativeElement.value = "";
    }

    this.driReports("-1", "-1", "-1", "-1", "-1", "-1", "-1", "-1", -1, this.perPage, this.driStartPage);
  }

  applyDRIFilter() {
    this.dri_fetch_page = 1;
    this.driStartPage = 1;
    this.driReports(
      this.driForm.value.from_city,
      this.driForm.value.to_city,
      this.driForm.value.from_date,
      this.driForm.value.to_date,
      this.driForm.value.truck_type,
      this.driForm.value.route_type,
      this.driForm.value.min_fare,
      this.driForm.value.max_fare,
      -1,
      this.perPage,
      this.driStartPage
    );
  }

  dridownloadXl() {
    let url = `/admin/report/driver-offline-routes/export?`;
    const fromCity = this.driForm.value.from_city;
    const toCity = this.driForm.value.to_city;
    const fromDate = this.driForm.value.from_date;
    const toDate = this.driForm.value.to_date;
    const truckType = this.driForm.value.truck_type;
    const routeType = this.driForm.value.route_type;
    const minFare = this.driForm.value.min_fare;
    const maxFare = this.driForm.value.max_fare;

    if (fromCity && fromCity != -1) url += `&from_city=${fromCity}`;
    if (toCity && toCity != -1) url += `&to_city=${toCity}`;
    if (fromDate && fromDate != -1) {
      const parsedFromDate = new Date(fromDate);
      if (!isNaN(parsedFromDate.getTime())) {
        url += `&fromDate=${formatDate(parsedFromDate, "yyyy-MM-dd", "en-US")}`;
      }
    }
    if (toDate && toDate != -1) {
      const parsedToDate = new Date(toDate);
      if (!isNaN(parsedToDate.getTime())) {
        url += `&toDate=${formatDate(parsedToDate, "yyyy-MM-dd", "en-US")}`;
      }
    }
    if (truckType && truckType != -1) url += `&truck_type=${truckType}`;
    if (routeType && routeType != -1) url += `&route_type=${routeType}`;
    if (minFare && minFare != -1) url += `&min_fare=${minFare}`;
    if (maxFare && maxFare != -1) url += `&max_fare=${maxFare}`;

    this.driExportLoading = true;
    const fullUrl = environment.base_url + environment.base_uri + url.substring(1);
    const header = new HttpHeaders({
      Authorization: "Bearer " + this.token,
    });

    this.http.get(fullUrl, { headers: header, responseType: "blob" }).subscribe(
      (blob: Blob) => {
        this.driExportLoading = false;
        const timestamp = formatDate(new Date(), "yyyyMMdd_HHmmss", "en-US");
        const downloadLink = document.createElement("a");
        const objectUrl = window.URL.createObjectURL(blob);
        downloadLink.href = objectUrl;
        downloadLink.download = `s9_offline_routes_${timestamp}.csv`;
        document.body.appendChild(downloadLink);
        downloadLink.click();
        document.body.removeChild(downloadLink);
        window.URL.revokeObjectURL(objectUrl);
      },
      (error) => {
        this.driExportLoading = false;
        this.snackBar.open("Export failed: " + (error.error?.message || error.message), "Fail", {
          duration: 5000,
        });
      }
    );
  }

  sortData(column: string) {
    if (this.report_type === "dri") {
      const isAsc = this.sortColumn === column && this.sortDirection === "asc";
      this.sortDirection = isAsc ? "desc" : "asc";
      this.sortColumn = column;

      this.driArray.sort((a: any, b: any) => {
        let valA: any, valB: any;
        switch (column) {
          case "id":
            valA = a.offline_route_unique_id?.toLowerCase() || "";
            valB = b.offline_route_unique_id?.toLowerCase() || "";
            break;
          case "date":
            valA = new Date(a.date);
            valB = new Date(b.date);
            break;
          case "from":
            valA = a.fromLocation?.from_city_name?.toLowerCase() || "";
            valB = b.fromLocation?.from_city_name?.toLowerCase() || "";
            break;
          case "to":
            valA = a.toLocation?.to_city_name?.toLowerCase() || "";
            valB = b.toLocation?.to_city_name?.toLowerCase() || "";
            break;
          case "category":
            valA = a.truck_category?.toLowerCase() || "";
            valB = b.truck_category?.toLowerCase() || "";
            break;
          case "type":
            valA = a.route_type?.toLowerCase() || "";
            valB = b.route_type?.toLowerCase() || "";
            break;
          case "material":
            valA = a.material?.toLowerCase() || "";
            valB = b.material?.toLowerCase() || "";
            break;
          case "vehicle_no":
            valA = a.truck_no?.toLowerCase() || "";
            valB = b.truck_no?.toLowerCase() || "";
            break;
          case "to_name":
            valA = a.truck_owner_name?.toLowerCase() || "";
            valB = b.truck_owner_name?.toLowerCase() || "";
            break;
          case "to_no":
            valA = a.truck_owner_number?.toLowerCase() || "";
            valB = b.truck_owner_number?.toLowerCase() || "";
            break;
          default:
            return 0;
        }
        if (valA < valB) return this.sortDirection === "asc" ? -1 : 1;
        if (valA > valB) return this.sortDirection === "asc" ? 1 : -1;
        return 0;
      });
    }
  }
}
